"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
(function () {
  var CABAUSPACE_VERSION = 'v1.0.6';
  var CABAUSPACE_API_BASE_URL = 'https://be-cabauspace.fly.dev';
  if (window._dbg) window._dbg('home.js loaded - ' + CABAUSPACE_VERSION);
  var dash = document.getElementById('cabau-dashboard');
  var out = document.getElementById('challenge-json');
  var currentChallengeWeek = 1; // Track current week from challenge data
  var disableMobileZoom = function disableMobileZoom() {
    try {
      var head = document.head || document.getElementsByTagName('head')[0];
      if (!head) return;
      var viewport = document.querySelector('meta[name="viewport"]');
      if (!viewport) {
        viewport = document.createElement('meta');
        viewport.setAttribute('name', 'viewport');
        head.appendChild(viewport);
      }
      viewport.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no');
    } catch (_) {}
  };
  disableMobileZoom();
  var normId = function normId(x) {
    return x ? String(x).split('/').pop() : '';
  };
  var sha256 = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(text) {
      var buf;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return crypto.subtle.digest('SHA-256', new TextEncoder().encode(text));
          case 1:
            buf = _context.v;
            return _context.a(2, _toConsumableArray(new Uint8Array(buf)).map(function (b) {
              return b.toString(16).padStart(2, '0');
            }).join(''));
        }
      }, _callee);
    }));
    return function sha256(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var setCustomer = function setCustomer(c) {
    if (window._dbg) window._dbg('setCustomer() c=' + JSON.stringify(c) + ' dash=' + !!dash);
    if (!c || !dash) return null;
    var id = normId(c.id);
    var email = c.email || '';
    var name = c.firstName || c.first_name || '';
    if (window._dbg) window._dbg('setCustomer: id=' + id + ' email=' + email + ' name=' + name);
    
    // Update dashboard data attributes
    if (id) dash.dataset.customerId = id;
    if (email) dash.dataset.customerEmail = email;
    if (name) dash.dataset.customerName = name;
    
    // Update quiz-summary-results data attributes (for quiz flow)
    var quizSummaryResults = document.getElementById('quiz-summary-results');
    if (quizSummaryResults) {
      if (id) quizSummaryResults.dataset.customerId = id;
      if (email) quizSummaryResults.dataset.customerEmail = email;
      if (name) quizSummaryResults.dataset.customerName = name;
    }
    
    // Update Typeform hidden fields with customer data
    updateTypeformHiddenFields(id, email, name);
    
    return id && email ? {
      id: id,
      email: email,
      name: name
    } : null;
  };
  
  var updateTypeformHiddenFields = function updateTypeformHiddenFields(id, email, name) {
    var typeformContainer = document.getElementById('typeform-container');
    if (!typeformContainer) return;
    var typeformEmbed = document.getElementById('typeform-embed');
    if (!typeformEmbed) return;
    
    // Get current session_id from container or generate new one
    var sessionId = typeformContainer.dataset.sessionId || (id ? id + '-' + Date.now() : 'guest-' + Date.now());
    
    // Update the data-tf-hidden attribute with customer data
    var hiddenFields = 'session_id=' + encodeURIComponent(sessionId) + ',email_web=' + encodeURIComponent(email || '') + ',name_web=' + encodeURIComponent(name || '');
    typeformEmbed.setAttribute('data-tf-hidden', hiddenFields);
    
    if (window._dbg) window._dbg('Updated Typeform hidden fields: ' + hiddenFields);
  };
  var fetchChallenge = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref2) {
      var id, email, code, res, json, _t;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            id = _ref2.id, email = _ref2.email;
            _context2.p = 1;
            _context2.n = 2;
            return sha256("".concat(id, ":").concat(email));
          case 2:
            code = _context2.v;
            _context2.n = 3;
            return fetch("".concat(CABAUSPACE_API_BASE_URL, "/api/challenge"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-store'
              },
              body: JSON.stringify({
                code: code,
                email: email,
                customer: id
              })
            });
          case 3:
            res = _context2.v;
            _context2.n = 4;
            return res.json();
          case 4:
            json = _context2.v;
            if (out) {
              out.textContent = JSON.stringify(json, null, 2);
            }
            _context2.n = 6;
            break;
          case 5:
            _context2.p = 5;
            _t = _context2.v;
            out.textContent = JSON.stringify({
              error: String(_t)
            }, null, 2);
          case 6:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 5]]);
    }));
    return function fetchChallenge(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var onReady = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var _window$StikkySDK;
      var urlParams, urlSessionId, ctx, _window$StikkySDK2, _window$StikkySDK2$on;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            if (window._dbg) window._dbg('onReady() called - ' + CABAUSPACE_VERSION);
            if (window._dbg) window._dbg('URL: ' + window.location.href);
            if (window._dbg) window._dbg('URL search: ' + window.location.search);
            // Check for session_id in URL - if present, show quiz summary directly
            urlParams = new URLSearchParams(window.location.search);
            urlSessionId = urlParams.get('session_id');
            if (window._dbg) window._dbg('urlSessionId=' + urlSessionId);
            if (!urlSessionId) {
              _context3.n = 2;
              break;
            }
            if (window._dbg) window._dbg('-> showQuizSummaryFromSessionId(' + urlSessionId + ')');
            _context3.n = 1;
            return showQuizSummaryFromSessionId(urlSessionId);
          case 1:
            return _context3.a(2);
          case 2:
            try {
              ctx = setCustomer((_window$StikkySDK = window.StikkySDK) === null || _window$StikkySDK === void 0 || (_window$StikkySDK = _window$StikkySDK.variables) === null || _window$StikkySDK === void 0 ? void 0 : _window$StikkySDK.customer);
            } catch (_sdkErr) {
              if (window._dbg) window._dbg('StikkySDK.variables.customer threw: ' + _sdkErr.message);
              ctx = setCustomer(null);
            }
            if (window._dbg) window._dbg('ctx=' + JSON.stringify(ctx) + ' hasCustomerData=' + hasCustomerData());
            if (ctx) fetchChallenge(ctx);
            if (ctx || hasCustomerData()) {
              if (window._dbg) window._dbg('-> initializeDashboard()');
              initializeDashboard();
            } else {
              if (window._dbg) window._dbg('-> showLoginPrompt()');
              showLoginPrompt();
            }
            try {
              (_window$StikkySDK2 = window.StikkySDK) === null || _window$StikkySDK2 === void 0 || (_window$StikkySDK2 = _window$StikkySDK2.events) === null || _window$StikkySDK2 === void 0 || (_window$StikkySDK2$on = _window$StikkySDK2.onCustomerUpdated) === null || _window$StikkySDK2$on === void 0 || _window$StikkySDK2$on.call(_window$StikkySDK2, function (c) {
                var ctx2 = setCustomer(c);
                if (ctx2) fetchChallenge(ctx2);
                if (ctx2 || hasCustomerData()) initializeDashboard();else showLoginPrompt();
              });
            } catch (_) {}
          case 3:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function onReady() {
      return _ref4.apply(this, arguments);
    };
  }();
  // Guard: onReady mag maar één keer draaien (event kan vroeger firen dan de listener door defer-volgorde)
  var _onReadyFired = false;
  var _guardedOnReady = function() {
    if (_onReadyFired) return;
    _onReadyFired = true;
    if (window._dbg) window._dbg('_guardedOnReady() called');
    onReady();
  };
  document.addEventListener('stikky-sdk-ready', _guardedOnReady);
  document.addEventListener('DOMContentLoaded', function () {
    if (window._dbg) window._dbg('home.js DOMContentLoaded - StikkySDK: ' + typeof window.StikkySDK);
    try {
      new window.StikkySDK().initialize();
      if (window._dbg) window._dbg('StikkySDK.initialize() called OK');
    } catch (e) {
      if (window._dbg) window._dbg('StikkySDK.initialize() ERROR: ' + e.message);
    }
  });
  // Fallback: als stikky-sdk-ready nooit fired (timing-issue defer of SDK niet beschikbaar in de app)
  setTimeout(_guardedOnReady, 1000);

  // ===== TYPEFORM DYNAMIC LOADER =====
  var typeformLoaded = false;
  var loadTypeformEmbed = function loadTypeformEmbed() {
    if (window._dbg) window._dbg('loadTypeformEmbed() called, typeformLoaded=' + typeformLoaded);
    if (typeformLoaded) return;
    typeformLoaded = true;
    // embed-typeform.js is now loaded directly via <script defer> in the liquid template
    // Just call tf.reload() to re-initialize widgets now that the container is visible
    if (window._dbg) window._dbg('window.tf type=' + typeof window.tf);
    if (window.tf && typeof window.tf.reload === 'function') {
      if (window._dbg) window._dbg('Calling window.tf.reload() to re-init widgets');
      try {
        window.tf.reload();
        if (window._dbg) window._dbg('window.tf.reload() called OK');
      } catch(err) {
        if (window._dbg) window._dbg('window.tf.reload() ERROR: ' + err.message);
      }
    } else if (window.tf && typeof window.tf.load === 'function') {
      if (window._dbg) window._dbg('tf.reload not available, calling tf.load()');
      window.tf.load();
    } else {
      if (window._dbg) window._dbg('window.tf NOT available - embed-typeform.js may not have loaded');
    }
    setTimeout(function() {
      var tfEmbed = document.getElementById('typeform-embed');
      var iframes = tfEmbed ? tfEmbed.querySelectorAll('iframe') : [];
      if (window._dbg) window._dbg('POST-RELOAD CHECK: tfEmbed children=' + (tfEmbed ? tfEmbed.childNodes.length : 'NULL') + ' iframes=' + iframes.length);
      for (var idx = 0; idx < iframes.length; idx++) {
        if (window._dbg) window._dbg('POST-RELOAD CHECK: iframe[' + idx + '] src=' + iframes[idx].src + ' h=' + iframes[idx].offsetHeight);
      }
    }, 2000);
  };

  // ===== UTILITIES =====
  var escapeHtml = function escapeHtml(str) {
    if (str === null || str === undefined) return '';
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  };
  var formatDate = function formatDate(dateStr) {
    var date = new Date(dateStr);
    var days = ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'];
    var months = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
    return days[date.getDay()] + ' ' + date.getDate() + ' ' + months[date.getMonth()];
  };
  var calculateDayNumber = function calculateDayNumber(startDateStr) {
    var startDate = new Date(startDateStr);
    var today = new Date();
    startDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return Math.floor((today - startDate) / (1000 * 60 * 60 * 24)) + 1;
  };
  var calculateWeekNumber = function calculateWeekNumber(dayNumber) {
    return Math.ceil(dayNumber / 7);
  };
  var getDayInWeek = function getDayInWeek(dayNumber) {
    var d = dayNumber % 7;
    return d === 0 ? 7 : d;
  };

  // ===== CUSTOMER DATA ===== up = clean, down is extra
  var hasCustomerData = function hasCustomerData() {
    if (!dash) return false;
    var id = (dash.dataset.customerId || '').trim();
    var email = (dash.dataset.customerEmail || '').trim();
    var liquidTag = '{' + '{';
    return id.length > 0 && !id.includes(liquidTag) && email.length > 0 && !email.includes(liquidTag);
  };

  // ===== UI HELPERS =====
  var showLoginPrompt = function showLoginPrompt() {
    var _typeformContainer$da;
    if (window._dbg) window._dbg('showLoginPrompt() executing');
    // Show quiz section, hide dashboard
    var quizSection = document.getElementById('cabauspace-quiz-section');
    var dashboard = document.getElementById('cabau-dashboard');
    var typeformContainer = document.getElementById('typeform-container');
    
    if (quizSection) quizSection.style.display = 'block';
    if (dashboard) dashboard.style.display = 'none';
    if (typeformContainer) typeformContainer.style.display = 'block';
    
    if (window._dbg) window._dbg('Quiz section visible, dashboard hidden');

    // Start polling with guest session_id
    var sessionId = typeformContainer === null || typeformContainer === void 0 || (_typeformContainer$da = typeformContainer.dataset) === null || _typeformContainer$da === void 0 ? void 0 : _typeformContainer$da.sessionId;
    if (sessionId) {
      console.log('Guest user - start polling met session_id:', sessionId);
      startQuizPolling(sessionId);
    }
  };
  var hideLoading = function hideLoading() {
    var loadingEl = document.getElementById('dashboard-loading');
    var contentEl = document.getElementById('dashboard-content');
    if (loadingEl) loadingEl.style.display = 'none';
    if (contentEl) contentEl.style.display = 'block';
  };
  var ensureCartOverlay = function ensureCartOverlay() {
    if (document.getElementById('cabauspace-cart-overlay')) return;
    var styleId = 'cabauspace-cart-overlay-style';
    if (!document.getElementById(styleId)) {
      var style = document.createElement('style');
      style.id = styleId;
      style.textContent = "\n        @keyframes cabauspaceSpin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }\n        .cabauspace-cart-spinner { width: 44px; height: 44px; border: 4px solid #e9e9e9; border-top: 4px solid #a0475a; border-radius: 50%; animation: cabauspaceSpin 0.9s linear infinite; }\n      ";
      document.head.appendChild(style);
    }
    var overlay = document.createElement('div');
    overlay.id = 'cabauspace-cart-overlay';
    overlay.style.cssText = 'display:none;position:fixed;inset:0;z-index:99999;background:rgba(255,255,255,0.95);align-items:center;justify-content:center;';
    overlay.innerHTML = "\n      <div style=\"display:flex;flex-direction:column;align-items:center;gap:14px;padding:24px;text-align:center;max-width:340px;\">\n        <div class=\"cabauspace-cart-spinner\"></div>\n        <p style=\"margin:0;font-size:16px;line-height:1.3;color:#111;font-weight:500;\">De producten worden aan uw winkelwagen toegevoegd.</p>\n      </div>\n    ";
    document.body.appendChild(overlay);
  };
  var showCartOverlay = function showCartOverlay() {
    ensureCartOverlay();
    var overlay = document.getElementById('cabauspace-cart-overlay');
    if (!overlay) return;
    overlay.style.display = 'flex';
    setTimeout(hideCartOverlay, 10000);
  };
  var hideCartOverlay = function hideCartOverlay() {
    var overlay = document.getElementById('cabauspace-cart-overlay');
    if (overlay) overlay.style.display = 'none';
  };

  // ===== PLAN LOADING OVERLAY =====
  var planLoadingIntervalId = null;
  var ensurePlanLoadingOverlay = function ensurePlanLoadingOverlay() {
    if (document.getElementById('cabauspace-plan-loading-overlay')) return;
    var overlay = document.createElement('div');
    overlay.id = 'cabauspace-plan-loading-overlay';
    overlay.style.cssText = 'display:none;position:fixed;inset:0;z-index:99999;background:#f9f1ea;align-items:center;justify-content:center;flex-direction:column;';
    overlay.innerHTML = "\n      <div style=\"display:flex;flex-direction:column;align-items:center;gap:24px;padding:24px;text-align:center;max-width:500px;width:90%;\">\n        <h2 style=\"font-family:'Quincy CF Light Regular',serif;font-size:1.8rem;color:#5c1026;margin:0;\">Even geduld...</h2>\n        <p class=\"cabauspace-plan-loading-text\" style=\"margin:0;font-size:1rem;line-height:1.5;color:#5c1026;font-weight:500;\">Bezig met het samenstellen van jouw persoonlijke challenge</p>\n        <div style=\"width:100%;max-width:400px;\">\n          <div style=\"height:8px;background:#e3d0c5;border-radius:4px;overflow:hidden;\">\n            <div id=\"cabauspace-plan-progress-bar\" style=\"height:100%;width:0%;background:linear-gradient(90deg,#a0475a,#5c1026);border-radius:4px;transition:width 0.1s linear;\"></div>\n          </div>\n        </div>\n      </div>\n    ";
    document.body.appendChild(overlay);
  };
  var showPlanLoadingOverlay = function showPlanLoadingOverlay() {
    ensurePlanLoadingOverlay();
    var overlay = document.getElementById('cabauspace-plan-loading-overlay');
    if (!overlay) return;
    overlay.style.display = 'flex';
    
    var progressBar = document.getElementById('cabauspace-plan-progress-bar');
    var loadingText = overlay.querySelector('.cabauspace-plan-loading-text');
    var loadingStages = [{
      percentage: 0,
      text: 'Het plan is gebaseerd op de producten die nu aan je winkelwagen worden toegevoegd.'
    },{
      percentage: 5,
      text: 'Dit duurt ± 3min, je hoeft niet te wachten, je ontvangt een mail wanneer het klaar is.'
    }, {
      percentage: 10,
      text: 'Bezig met het samenstellen van jouw persoonlijke challenge'
    }, {
      percentage: 33,
      text: 'Inrichten van jouw persoonlijke voedingsschema'
    }, {
      percentage: 66,
      text: 'Bouwen aan jouw persoonlijke fitnessplan'
    }, {
      percentage: 95,
      text: 'Bijna klaar...'
    }];
    var progressDuration = 180000; // 3 minutes (cosmetic only, animation holds at 95% after this)
    var progressInterval = 100;
    var progressElapsed = 0;

    // Clear any existing interval
    if (planLoadingIntervalId) clearInterval(planLoadingIntervalId);

    planLoadingIntervalId = setInterval(function () {
      progressElapsed += progressInterval;
      var pct = Math.min(progressElapsed / progressDuration * 100, 95);
      if (progressBar) {
        progressBar.style.width = pct + '%';
      }
      if (loadingText) {
        for (var i = loadingStages.length - 1; i >= 0; i--) {
          if (pct >= loadingStages[i].percentage) {
            loadingText.textContent = loadingStages[i].text;
            break;
          }
        }
      }
      // Cosmetic animation stops here - the real hide happens once polling confirms the challenge is ready
      if (progressElapsed >= progressDuration) {
        clearInterval(planLoadingIntervalId);
        planLoadingIntervalId = null;
      }
    }, progressInterval);

    // Start real polling: check every second whether the challenge is actually in the database
    startChallengePolling();
  };
  var hidePlanLoadingOverlay = function hidePlanLoadingOverlay() {
    var overlay = document.getElementById('cabauspace-plan-loading-overlay');
    if (overlay) overlay.style.display = 'none';
    if (planLoadingIntervalId) {
      clearInterval(planLoadingIntervalId);
      planLoadingIntervalId = null;
    }
    stopChallengePolling();
  };

  // ===== CHALLENGE POLLING (used while the plan loading overlay is visible) =====
  var challengePollIntervalId = null;
  var challengePollAttempts = 0;
  var CHALLENGE_POLL_MAX_ATTEMPTS = 900; // ~15 minutes at 1 poll/second, safety cap
  var stopChallengePolling = function stopChallengePolling() {
    if (challengePollIntervalId) {
      clearInterval(challengePollIntervalId);
      challengePollIntervalId = null;
    }
    challengePollAttempts = 0;
  };
  var pollChallengeOnce = function pollChallengeOnce() {
    var customerId = dash && dash.dataset.customerId;
    var customerEmail = dash && dash.dataset.customerEmail;
    if (!customerId || !customerEmail) {
      // Geen ingelogde klant - er kan nooit een hash-gebaseerd resultaat komen, dus stoppen
      stopChallengePolling();
      return;
    }
    challengePollAttempts++;
    if (challengePollAttempts > CHALLENGE_POLL_MAX_ATTEMPTS) {
      stopChallengePolling();
      return;
    }
    sha256("".concat(customerId, ":").concat(customerEmail)).then(function (code) {
      return fetch("".concat(CABAUSPACE_API_BASE_URL, "/api/challenge"), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          code: code,
          email: customerEmail,
          customer: customerId
        })
      });
    }).then(function (response) {
      if (!response.ok) return null;
      return response.json();
    }).then(function (json) {
      if (!json) return;
      var data = json.data || json;
      if (json.status === 'COMPLETED' && data && data.weeks && data.weeks.length && data.challenge_period) {
        stopChallengePolling();
        hidePlanLoadingOverlay();
        initializeDashboard();
      }
    }).catch(function () {
      // Network hiccup - keep polling, next tick will retry
    });
  };
  var startChallengePolling = function startChallengePolling() {
    if (challengePollIntervalId) return; // already polling
    challengePollAttempts = 0;
    pollChallengeOnce();
    challengePollIntervalId = setInterval(pollChallengeOnce, 1000);
  };

  // ===== TAB NAVIGATION =====
  var initDashboardTabs = function initDashboardTabs() {
    var _initialActiveTab$dat;
    var tabs = document.querySelectorAll('.dashboard-tab');
    var panels = document.querySelectorAll('.dashboard-panel');
    var header = document.querySelector('.dashboard-header');
    var tabsWrapper = document.querySelector('.dashboard-tabs-wrapper');

    // Ensure tabs/menu are above the banner/header
    if (header && tabsWrapper && header.parentNode === tabsWrapper.parentNode) {
      header.parentNode.insertBefore(tabsWrapper, header);
    }
    var setHeaderVisibility = function setHeaderVisibility(targetId) {
      if (!header) return;
      header.style.display = targetId === 'challenges' ? '' : 'none';
    };

    // Set initial visibility based on currently active tab
    var initialActiveTab = document.querySelector('.dashboard-tab.active');
    setHeaderVisibility((initialActiveTab === null || initialActiveTab === void 0 || (_initialActiveTab$dat = initialActiveTab.dataset) === null || _initialActiveTab$dat === void 0 ? void 0 : _initialActiveTab$dat.tab) || 'challenges');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var _document$getElementB;
        var targetId = tab.dataset.tab;
        tabs.forEach(function (t) {
          return t.classList.remove('active');
        });
        tab.classList.add('active');
        panels.forEach(function (p) {
          return p.classList.remove('active');
        });
        (_document$getElementB = document.getElementById(targetId)) === null || _document$getElementB === void 0 || _document$getElementB.classList.add('active');
        setHeaderVisibility(targetId);
      });
    });
  };

  // ===== MOOD BUTTONS =====
  var initMoodButtons = function initMoodButtons() {
    var moodBtns = document.querySelectorAll('.mood-btn');
    moodBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        moodBtns.forEach(function (b) {
          return b.classList.remove('active');
        });
        btn.classList.add('active');
      });
    });
  };

  // ===== CONFETTI =====
  var createConfetti = function createConfetti(originElement) {
    var colors = ['#F7C2CF', '#fce6ed', '#d9768b', '#ff9eb5', '#ffb6c1'];
    var rect = originElement.getBoundingClientRect();
    var originX = rect.left + rect.width / 2;
    var originY = rect.top + rect.height / 2;
    var _loop = function _loop() {
      var confetti = document.createElement('div');
      confetti.style.cssText = "position:fixed;width:".concat(Math.random() * 10 + 5, "px;height:").concat(Math.random() * 10 + 5, "px;background:").concat(colors[Math.floor(Math.random() * colors.length)], ";left:").concat(originX, "px;top:").concat(originY, "px;border-radius:").concat(Math.random() > 0.5 ? '50%' : '0', ";pointer-events:none;z-index:9999;opacity:1;");
      document.body.appendChild(confetti);
      var angle = Math.random() * 360 * (Math.PI / 180);
      var velocity = Math.random() * 200 + 100;
      var vx = Math.cos(angle) * velocity;
      var vy = Math.sin(angle) * velocity - 150;
      var startTime = performance.now();
      var _animate = function animate(currentTime) {
        var elapsed = (currentTime - startTime) / 1000;
        var x = vx * elapsed;
        var y = vy * elapsed + 0.5 * 300 * elapsed * elapsed;
        var opacity = Math.max(0, 1 - elapsed / 2);
        confetti.style.transform = "translate(".concat(x, "px, ").concat(y, "px) rotate(").concat(elapsed * 360, "deg)");
        confetti.style.opacity = opacity;
        if (opacity > 0) requestAnimationFrame(_animate);else confetti.remove();
      };
      requestAnimationFrame(_animate);
    };
    for (var i = 0; i < 50; i++) {
      _loop();
    }
  };

  // ===== CHALLENGE COMPLETION =====
  var updateChallengeCompletion = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(weekNumber, dayNumber, completed) {
      var customerId, customerEmail, code, _t2;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            customerId = dash.dataset.customerId;
            customerEmail = dash.dataset.customerEmail;
            if (!(!customerId || !customerEmail)) {
              _context4.n = 1;
              break;
            }
            return _context4.a(2);
          case 1:
            _context4.p = 1;
            _context4.n = 2;
            return sha256("".concat(customerId, ":").concat(customerEmail));
          case 2:
            code = _context4.v;
            _context4.n = 3;
            return fetch("".concat(CABAUSPACE_API_BASE_URL, "/api/challenge/complete"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                code: code,
                email: customerEmail,
                customer: customerId,
                weekNumber: weekNumber,
                dayNumber: dayNumber,
                completed: completed
              })
            });
          case 3:
            _context4.n = 5;
            break;
          case 4:
            _context4.p = 4;
            _t2 = _context4.v;
          case 5:
            return _context4.a(2);
        }
      }, _callee4, null, [[1, 4]]);
    }));
    return function updateChallengeCompletion(_x3, _x4, _x5) {
      return _ref5.apply(this, arguments);
    };
  }();
  var initResetQuizButton = function initResetQuizButton() {
    var resetBtns = [document.getElementById('reset-quiz-btn'), document.getElementById('reset-quiz-btn-summary')];
    resetBtns.forEach(function(resetBtn) {
      if (resetBtn && !resetBtn.dataset.initialized) {
        resetBtn.dataset.initialized = 'true';
        resetBtn.addEventListener('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
          var customerId, customerEmail, quizSummary, code, confirmDelete, response, result;
          return _regenerator().w(function (_context5) {
            while (1) switch (_context5.p = _context5.n) {
              case 0:
                customerId = dash ? dash.dataset.customerId : null;
                customerEmail = dash ? dash.dataset.customerEmail : null;
                if (!customerId || !customerEmail) {
                  quizSummary = document.getElementById('quiz-summary-results');
                  if (quizSummary) {
                    customerId = quizSummary.dataset.customerId;
                    customerEmail = quizSummary.dataset.customerEmail;
                  }
                }
                if (!(!customerId || !customerEmail)) {
                  _context5.n = 1;
                  break;
                }
                return _context5.a(2);
              case 1:
                confirmDelete = confirm('Weet je zeker dat je al je quiz resultaten wilt verwijderen? Deze actie kan niet ongedaan gemaakt worden.');
                if (confirmDelete) {
                  _context5.n = 2;
                  break;
                }
                return _context5.a(2);
              case 2:
                _context5.p = 2;
                _context5.n = 3;
                return sha256("".concat(customerId, ":").concat(customerEmail));
              case 3:
                code = _context5.v;
                _context5.n = 4;
                return fetch("".concat(CABAUSPACE_API_BASE_URL, "/api/quiz-result/delete"), {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    code: code,
                    email: customerEmail,
                    customer: customerId
                  })
                });
              case 4:
                response = _context5.v;
                _context5.n = 5;
                return response.json();
              case 5:
                result = _context5.v;
                if (result.success) {
                  alert('Je quiz resultaten zijn succesvol verwijderd. De quiz wordt nu opnieuw geladen zodat je deze opnieuw kunt invullen.');
                  
                  // Re-render de pagina zonder window.location.reload()
                  var quizSection = document.getElementById('cabauspace-quiz-section');
                  var dashboard = document.getElementById('cabau-dashboard');
                  var resultsContainer = document.getElementById('quiz-summary-results');
                  var quizWrapper = document.getElementById('custom-quiz-wrapper');
                  var loader = document.getElementById('cabauspace-loading-screen');
                  
                  // Verberg dashboard en results
                  if (dashboard) dashboard.style.display = 'none';
                  if (resultsContainer) resultsContainer.style.display = 'none';
                  if (loader) loader.style.display = 'none';
                  
                  // Toon quiz sectie en wrapper
                  if (quizSection) quizSection.style.display = 'block';
                  if (quizWrapper) quizWrapper.style.display = 'block';
                  
                  // Reset quiz naar eerste stap
                  if (window.showStep) window.showStep(1);
                } else {
                  alert('Er is een fout opgetreden bij het verwijderen van je resultaten. Probeer het later opnieuw.');
                }
                _context5.n = 8;
                break;
              case 6:
                _context5.p = 6;
                _context5.t0 = _context5.v;
                console.error('Error deleting quiz data:', _context5.t0);
                alert('Er is een fout opgetreden. Probeer het later opnieuw.');
              case 8:
                return _context5.a(2);
            }
          }, _callee5, null, [[2, 6]]);
        })));
      }
    });
  };
  var initChallengeButtons = function initChallengeButtons() {
    var yesterdayScoreBtn = document.getElementById('yesterday-score');
    if (yesterdayScoreBtn && !yesterdayScoreBtn.dataset.listenerAttached) {
      yesterdayScoreBtn.dataset.listenerAttached = 'true';
      yesterdayScoreBtn.addEventListener('click', function() {
        var btn = this;
        var weekNumber = parseInt(btn.dataset.week);
        var dayNumber = parseInt(btn.dataset.day);
        var isCompleted = btn.dataset.completed === 'true';
        var newCompleted = !isCompleted;
        btn.dataset.completed = newCompleted.toString();
        var statusEl = document.getElementById('yesterday-status');
        if (newCompleted) {
          btn.classList.add('completed');
          if (statusEl) statusEl.textContent = 'Lekker bezig!';
          createConfetti(btn);
        } else {
          btn.classList.remove('completed');
          if (statusEl) statusEl.textContent = 'Klik om te voltooien';
        }
        updateChallengeCompletion(weekNumber, dayNumber, newCompleted);
      });
    }
    var todayScoreBtn = document.getElementById('today-score');
    if (todayScoreBtn && !todayScoreBtn.dataset.listenerAttached) {
      todayScoreBtn.dataset.listenerAttached = 'true';
      todayScoreBtn.addEventListener('click', function() {
        var btn = this;
        var weekNumber = parseInt(btn.dataset.week);
        var dayNumber = parseInt(btn.dataset.day);
        var isCompleted = btn.dataset.completed === 'true';
        var newCompleted = !isCompleted;
        btn.dataset.completed = newCompleted.toString();
        var statusEl = document.getElementById('today-status');
        if (newCompleted) {
          btn.classList.add('completed');
          btn.classList.remove('empty');
          if (statusEl) statusEl.textContent = 'Lekker bezig!';
          createConfetti(btn);
        } else {
          btn.classList.remove('completed');
          if (statusEl) statusEl.textContent = 'Klik om te voltooien';
        }
        updateChallengeCompletion(weekNumber, dayNumber, newCompleted);
        // Klaviyo Tracking: Cabauspace - Challenge checked (only when checked, not unchecked)
        if (newCompleted) {
          try {
            var trackEmail = dash && dash.dataset.customerEmail;
            var trackCustomerId = dash && dash.dataset.customerId;
            if (trackEmail && trackCustomerId && window.dashboardTomorrowChallenge) {
              sha256(trackCustomerId + ':' + trackEmail).then(function(trackHash) {
                fetch(CABAUSPACE_API_BASE_URL + '/api/klaviyo/challenge-checked', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    email: trackEmail,
                    hash: trackHash,
                    tomorrow_challenge_title: window.dashboardTomorrowChallenge.title || '',
                    tomorrow_challenge_description: window.dashboardTomorrowChallenge.description || '',
                    tomorrow_challenge_why: window.dashboardTomorrowChallenge.why || ''
                  })
                }).catch(function(e) { console.error('Klaviyo tracking failed:', e); });
              });
            }
          } catch (kErr) {
            console.error('Klaviyo Challenge checked tracking failed:', kErr);
          }
        }
      });
    }
  };

  // ===== RENDER DASHBOARD (CHALLENGES) =====
  var renderDashboard = function renderDashboard(response) {
    try {
      var data = response.data || response;
      if (!data || !data.weeks || !data.weeks.length || !data.challenge_period) {
        document.getElementById('dashboard-loading').innerHTML = '<p class="mc-error">Geen challenge data gevonden.</p>';
        return;
      }
      // User has dashboard data - now hide quiz and show dashboard
      var quizSection = document.getElementById('cabauspace-quiz-section');
      if (quizSection) quizSection.style.display = 'none';
      var startDateStr = data.challenge_period.start_date;
      var endDateStr = data.challenge_period.end_date;
      var totalDays = 28;
      var rawDayNumber = calculateDayNumber(startDateStr);
      var challengeStarted = rawDayNumber >= 1;
      var challengeOver = rawDayNumber > totalDays;
      var isLastDay = rawDayNumber === totalDays;
      var currentDay = Math.max(1, Math.min(totalDays, rawDayNumber));
      var currentWeek = calculateWeekNumber(currentDay);
      var safeWeekIndex = Math.min(Math.max(0, currentWeek - 1), data.weeks.length - 1);
      var weekData = data.weeks[safeWeekIndex];
      if (!weekData) throw new Error('Geen weekdata');
      var dailyChallenges = weekData.daily_challenges || [];
      
      // Find today's and tomorrow's challenge
      // Supports two JSON formats:
      //   - Absolute: day is 1-28 across all weeks (week 2 has days 8-14)
      //   - Relative: day is 1-7 per week (week 2 also has days 1-7)
      var todayAbsoluteDay = challengeStarted ? currentDay : 1;
      var tomorrowAbsoluteDay = todayAbsoluteDay + 1;

      // Calculate which week index for today and tomorrow
      var todayWeekIndex = Math.floor((todayAbsoluteDay - 1) / 7);
      var tomorrowWeekIndex = Math.floor((tomorrowAbsoluteDay - 1) / 7);
      var todayDayInWeek = getDayInWeek(todayAbsoluteDay); // 1-7
      var tomorrowDayInWeek = getDayInWeek(tomorrowAbsoluteDay); // 1-7

      // Get today's challenge: try absolute day first, fall back to relative (day-in-week)
      var todayChallenge = null;
      if (data.weeks[todayWeekIndex] && data.weeks[todayWeekIndex].daily_challenges) {
        todayChallenge = data.weeks[todayWeekIndex].daily_challenges.find(function (c) {
          return c.day === todayAbsoluteDay;
        }) || data.weeks[todayWeekIndex].daily_challenges.find(function (c) {
          return c.day === todayDayInWeek;
        });
      }

      // Get tomorrow's challenge: try absolute day first, fall back to relative (day-in-week)
      var tomorrowChallenge = null;
      if (tomorrowAbsoluteDay <= totalDays && data.weeks[tomorrowWeekIndex] && data.weeks[tomorrowWeekIndex].daily_challenges) {
        tomorrowChallenge = data.weeks[tomorrowWeekIndex].daily_challenges.find(function (c) {
          return c.day === tomorrowAbsoluteDay;
        }) || data.weeks[tomorrowWeekIndex].daily_challenges.find(function (c) {
          return c.day === tomorrowDayInWeek;
        });
      }

      // Get yesterday's challenge: only when the challenge has started and there is a previous day
      var yesterdayChallenge = null;
      var yesterdayAbsoluteDay = todayAbsoluteDay - 1;
      var yesterdayWeekIndex = Math.floor((yesterdayAbsoluteDay - 1) / 7);
      if (challengeStarted && yesterdayAbsoluteDay >= 1 && data.weeks[yesterdayWeekIndex] && data.weeks[yesterdayWeekIndex].daily_challenges) {
        var yesterdayDayInWeek = getDayInWeek(yesterdayAbsoluteDay); // 1-7
        yesterdayChallenge = data.weeks[yesterdayWeekIndex].daily_challenges.find(function (c) {
          return c.day === yesterdayAbsoluteDay;
        }) || data.weeks[yesterdayWeekIndex].daily_challenges.find(function (c) {
          return c.day === yesterdayDayInWeek;
        });
      }

      // Update header and labels based on whether challenge has started
      var titleEl = document.getElementById('today-challenge-title');
      var firstCardLabel = document.querySelector('.challenge-card:not(.tomorrow):not(.yesterday) .challenge-label');
      var secondCardLabel = document.querySelector('.challenge-card.tomorrow .challenge-label');
      
      if (!challengeStarted) {
        // Challenge hasn't started - update labels to MORGEN/OVERMORGEN
        if (titleEl) titleEl.textContent = todayChallenge ? "Morgen focussen we op ".concat(todayChallenge.title.toLowerCase()) : 'Morgen start jouw challenge';
        if (firstCardLabel) firstCardLabel.textContent = 'MORGEN:';
        if (secondCardLabel) secondCardLabel.textContent = 'OVERMORGEN:';
      } else {
        // Challenge has started - use normal VANDAAG/MORGEN labels
        if (titleEl) titleEl.textContent = todayChallenge ? "Vandaag focussen we op ".concat(todayChallenge.title.toLowerCase()) : 'Vandaag focussen we op jouw gezondheid';
        if (firstCardLabel) firstCardLabel.textContent = 'VANDAAG:';
        if (secondCardLabel) secondCardLabel.textContent = 'MORGEN:';
      }

      // Update today's challenge
      var descEl = document.getElementById('today-description');
      var whyEl = document.getElementById('today-why');
      if (descEl) descEl.textContent = (todayChallenge === null || todayChallenge === void 0 ? void 0 : todayChallenge.description) || '';
      if (whyEl) whyEl.textContent = (todayChallenge === null || todayChallenge === void 0 ? void 0 : todayChallenge.why) || '';
      var todayScoreBtn = document.getElementById('today-score');
      if (todayScoreBtn && todayChallenge) {
        todayScoreBtn.dataset.week = currentWeek;
        todayScoreBtn.dataset.day = todayChallenge.day;
        todayScoreBtn.dataset.completed = todayChallenge.completed ? 'true' : 'false';
        todayScoreBtn.dataset.started = challengeStarted ? 'true' : 'false';
        var statusEl = document.getElementById('today-status');
        
        if (!challengeStarted) {
          // Challenge hasn't started - disable the button
          todayScoreBtn.disabled = true;
          todayScoreBtn.classList.add('empty');
          todayScoreBtn.classList.remove('completed');
          if (statusEl) statusEl.textContent = 'Morgen pas te voltooien';
        } else if (todayChallenge.completed) {
          todayScoreBtn.disabled = false;
          todayScoreBtn.classList.add('completed');
          todayScoreBtn.classList.remove('empty');
          if (statusEl) statusEl.textContent = 'Lekker bezig!';
        } else {
          todayScoreBtn.disabled = false;
          todayScoreBtn.classList.remove('completed');
          if (statusEl) statusEl.textContent = 'Klik om te voltooien';
        }
      }

      // Update tomorrow's challenge
      if (tomorrowChallenge) {
        var tomDesc = document.getElementById('tomorrow-description');
        var tomWhy = document.getElementById('tomorrow-why');
        if (tomDesc) tomDesc.textContent = tomorrowChallenge.description;
        if (tomWhy) tomWhy.textContent = tomorrowChallenge.why;

        // Store tomorrow's challenge globally for Klaviyo tracking
        window.dashboardTomorrowChallenge = tomorrowChallenge;
      }

      // Update yesterday's challenge (checkable, unlike tomorrow's card)
      var yesterdayCard = document.querySelector('.challenge-card.yesterday');
      if (yesterdayCard) {
        if (yesterdayChallenge && !challengeOver) {
          var yesDesc = document.getElementById('yesterday-description');
          var yesWhy = document.getElementById('yesterday-why');
          if (yesDesc) yesDesc.textContent = yesterdayChallenge.description || '';
          if (yesWhy) yesWhy.textContent = yesterdayChallenge.why || '';
          var yesterdayScoreBtn = document.getElementById('yesterday-score');
          if (yesterdayScoreBtn) {
            yesterdayScoreBtn.dataset.week = yesterdayWeekIndex + 1;
            yesterdayScoreBtn.dataset.day = yesterdayChallenge.day;
            yesterdayScoreBtn.dataset.completed = yesterdayChallenge.completed ? 'true' : 'false';
            var yesStatusEl = document.getElementById('yesterday-status');
            if (yesterdayChallenge.completed) {
              yesterdayScoreBtn.classList.add('completed');
              if (yesStatusEl) yesStatusEl.textContent = 'Lekker bezig!';
            } else {
              yesterdayScoreBtn.classList.remove('completed');
              if (yesStatusEl) yesStatusEl.textContent = 'Klik om te voltooien';
            }
          }
          yesterdayCard.style.display = '';
        } else {
          yesterdayCard.style.display = 'none';
        }
      }

      // Hide challenge cards when challenge is over or on the last day
      var todayCard = document.querySelector('.challenge-card:not(.tomorrow):not(.yesterday)');
      var tomorrowCard = document.querySelector('.challenge-card.tomorrow');
      if (challengeOver) {
        if (todayCard) todayCard.style.display = 'none';
        if (tomorrowCard) tomorrowCard.style.display = 'none';
        var challengeCards = document.querySelector('.challenge-cards');
        if (challengeCards && !document.getElementById('challenge-over-message')) {
          var msg = document.createElement('p');
          msg.id = 'challenge-over-message';
          msg.style.cssText = 'text-align:center;padding:1.5rem;color:#5c1026;font-weight:500;';
          msg.textContent = 'Goed bezig! Je challenge is afgelopen, verwijder hieronder het resultaat en begin opnieuw.';
          challengeCards.appendChild(msg);
        }
      } else if (isLastDay) {
        if (tomorrowCard) tomorrowCard.style.display = 'none';
      }

      // When the yesterday card is shown, start the carousel at today's card
      if (yesterdayCard && yesterdayCard.style.display !== 'none' && todayCard) {
        setTimeout(function () {
          var cardsContainer = document.querySelector('.challenge-cards');
          if (!cardsContainer) return;
          var target = todayCard.getBoundingClientRect().left - cardsContainer.getBoundingClientRect().left + cardsContainer.scrollLeft - 24;
          cardsContainer.scrollLeft = Math.max(0, target);
        }, 0);
      }

      // Update week progress
      var curWeekEl = document.getElementById('current-week');
      var focusEl = document.getElementById('week-focus-text');
      if (curWeekEl) curWeekEl.textContent = currentWeek;
      if (focusEl) focusEl.textContent = weekData.theme || weekData.week_goal || '';

      // Store current week for shuffle meal plan
      currentChallengeWeek = currentWeek;
      var progressPercentage = Math.round(currentDay / totalDays * 100);
      var progBar = document.getElementById('progress-bar');
      var progText = document.getElementById('progress-percentage');
      if (progBar) progBar.style.width = progressPercentage + '%';
      if (progText) progText.textContent = progressPercentage + '%';
      var startLbl = document.getElementById('start-date-label');
      var endLbl = document.getElementById('end-date-label');
      if (startLbl) startLbl.textContent = formatDate(startDateStr);
      if (endLbl) endLbl.textContent = formatDate(endDateStr);

      // Klaviyo Tracking: Cabauspace - Open plan (via backend)
      try {
        var trackEmail = dash && dash.dataset.customerEmail;
        var trackCustomerId = dash && dash.dataset.customerId;
        if (trackEmail && trackCustomerId && todayChallenge) {
          sha256(trackCustomerId + ':' + trackEmail).then(function(trackHash) {
            fetch(CABAUSPACE_API_BASE_URL + '/api/klaviyo/open-plan', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                email: trackEmail,
                hash: trackHash,
                challenge_title: todayChallenge.title || '',
                challenge_description: todayChallenge.description || '',
                challenge_why: todayChallenge.why || '',
                tomorrow_challenge_title: tomorrowChallenge ? tomorrowChallenge.title || '' : '',
                tomorrow_challenge_description: tomorrowChallenge ? tomorrowChallenge.description || '' : '',
                tomorrow_challenge_why: tomorrowChallenge ? tomorrowChallenge.why || '' : ''
              })
            }).catch(function(e) { console.error('Klaviyo tracking failed:', e); });
          });
        }
      } catch (kErr) {
        console.error('Klaviyo Open plan tracking failed:', kErr);
      }
    } catch (err) {
      document.getElementById('dashboard-loading').innerHTML = '<p>Er is een fout opgetreden.</p>';
    } finally {
      hideLoading();
      // Re-attach challenge button listeners after DOM is rendered
      initChallengeButtons();
    }
  };

  // ===== FETCH CHALLENGE DATA =====
  var fetchDashboardData = function fetchDashboardData() {
    var customerId = dash.dataset.customerId;
    var customerEmail = dash.dataset.customerEmail;
    if (!customerId || !customerEmail) {
      hideLoading();
      return;
    }
    sha256("".concat(customerId, ":").concat(customerEmail)).then(function (code) {
      return fetch("".concat(CABAUSPACE_API_BASE_URL, "/api/challenge"), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          code: code,
          email: customerEmail,
          customer: customerId
        })
      });
    }).then(function (response) {
      if (!response.ok) {
        var err = new Error('Backend error');
        err.status = response.status;
        throw err;
      }
      return response.json();
    }).then(function (json) {
      var data = json.data || json;
      if (json.status === 'COMPLETED' && data && data.weeks && data.weeks.length && data.challenge_period) {
        renderDashboard(json);
      } else {
        // Challenge nog niet klaar (PROCESSING/FAILED) - toon laadscherm en poll tot hij klaar is
        hideLoading();
        showPlanLoadingOverlay();
      }
    }).catch(function (err) {
      if (err && err.status === 404) {
        // Geen plan - check eerst of er een recommendation is
        hideLoading();
        checkForRecommendationOrShowQuiz();
        return;
      }
      hideLoading();
    });
  };

  // ===== QUIZ FLOW =====
  // Show quiz summary directly from session_id in URL
  var showQuizSummaryFromSessionId = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(sessionId) {
      var quizSection, dashboard, typeformContainer, loader, resultsContainer, response, json, status, data, _t4;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            if (window._dbg) window._dbg('showQuizSummaryFromSessionId(' + sessionId + ') START');
            quizSection = document.getElementById('cabauspace-quiz-section');
            dashboard = document.getElementById('cabau-dashboard');
            typeformContainer = document.getElementById('typeform-container');
            loader = document.getElementById('cabauspace-loading-screen');
            resultsContainer = document.getElementById('quiz-summary-results'); // Hide dashboard, show quiz section with loader
            if (window._dbg) window._dbg('Elements: quiz=' + !!quizSection + ' dash=' + !!dashboard + ' tf=' + !!typeformContainer + ' loader=' + !!loader + ' results=' + !!resultsContainer);
            if (dashboard) dashboard.style.display = 'none';
            if (quizSection) quizSection.style.display = 'block';
            if (typeformContainer) typeformContainer.style.display = 'none';
            if (loader) loader.style.display = 'flex';
            if (window._dbg) window._dbg('Fetching /api/quiz-result/' + sessionId);
            _context7.p = 1;
            _context7.n = 2;
            return fetch("".concat(CABAUSPACE_API_BASE_URL, "/api/quiz-result/").concat(encodeURIComponent(sessionId)), {
              method: 'GET',
              headers: {
                'Accept': 'application/json'
              }
            });
          case 2:
            response = _context7.v;
            if (window._dbg) window._dbg('Fetch response: status=' + response.status + ' ok=' + response.ok);
            if (response.ok) {
              _context7.n = 3;
              break;
            }
            if (window._dbg) window._dbg('Quiz result NOT FOUND for session_id: ' + sessionId);
            console.log('Quiz result niet gevonden voor session_id:', sessionId);
            if (loader) loader.style.display = 'none';
            if (resultsContainer) {
              resultsContainer.style.display = 'block';
              resultsContainer.innerHTML = '<p style="text-align:center;padding:2rem;">Geen quiz resultaat gevonden voor deze sessie.</p>';
            }
            return _context7.a(2);
          case 3:
            _context7.n = 4;
            return response.json();
          case 4:
            json = _context7.v;
            status = json.status || json.data && json.data.status;
            data = json.data || json;
            if (window._dbg) window._dbg('Quiz result status=' + status + ' hasMetabolicSummary=' + !!(data && data.metabolicSummary));
            if (status === 'COMPLETED' && data && data.metabolicSummary) {
              // Render quiz summary
              if (window._dbg) window._dbg('-> COMPLETED branch: rendering quiz results');
              if (loader) loader.style.display = 'none';
              renderQuizResults(data);
              if (resultsContainer) resultsContainer.style.display = 'block';
            } else if (status === 'PROCESSING') {
              // Still processing - start polling
              if (window._dbg) window._dbg('-> PROCESSING branch: start polling');
              startQuizPolling(sessionId);
            } else {
              // Waiting or other status - show Typeform and start polling
              // Typeform widget is already initialized by SDK at DOMContentLoaded (container starts visible)
              if (window._dbg) window._dbg('-> WAITING/OTHER branch: show typeform + start polling');
              if (loader) loader.style.display = 'none';
              if (typeformContainer) typeformContainer.style.display = 'block';
              startQuizPolling(sessionId);
            }
            _context7.n = 6;
            break;
          case 5:
            _context7.p = 5;
            _t4 = _context7.v;
            console.error('Error fetching quiz result:', _t4);
            if (loader) loader.style.display = 'none';
            if (resultsContainer) {
              resultsContainer.style.display = 'block';
              resultsContainer.innerHTML = '<p style="text-align:center;padding:2rem;">Er ging iets mis bij het ophalen van het resultaat.</p>';
            }
          case 6:
            return _context7.a(2);
        }
      }, _callee7, null, [[1, 5]]);
    }));
    return function showQuizSummaryFromSessionId(_x6) {
      return _ref8.apply(this, arguments);
    };
  }();

  // Check for existing recommendation using customer hash, or show Typeform quiz
  var checkForRecommendationOrShowQuiz = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
      var _dash$dataset, _dash$dataset2, _typeformContainer$da2;
      var quizSection, dashboard, typeformContainer, loader, resultsContainer, customerId, customerEmail, code, response, json, data, sessionId, _t5;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.p = _context8.n) {
          case 0:
            quizSection = document.getElementById('cabauspace-quiz-section');
            dashboard = document.getElementById('cabau-dashboard');
            typeformContainer = document.getElementById('typeform-container');
            loader = document.getElementById('cabauspace-loading-screen');
            resultsContainer = document.getElementById('quiz-summary-results');
            customerId = dash === null || dash === void 0 || (_dash$dataset = dash.dataset) === null || _dash$dataset === void 0 ? void 0 : _dash$dataset.customerId;
            customerEmail = dash === null || dash === void 0 || (_dash$dataset2 = dash.dataset) === null || _dash$dataset2 === void 0 ? void 0 : _dash$dataset2.customerEmail;
            if (!(!customerId || !customerEmail)) {
              _context8.n = 1;
              break;
            }
            console.log('Geen customer data, toon Typeform');
            if (dashboard) dashboard.style.display = 'none';
            if (quizSection) quizSection.style.display = 'block';
            if (typeformContainer) typeformContainer.style.display = 'block';
            return _context8.a(2);
          case 1:
            // Hide dashboard, show quiz section
            if (dashboard) dashboard.style.display = 'none';
            if (quizSection) quizSection.style.display = 'block';

            // Try to fetch existing recommendation using customer hash
            _context8.p = 2;
            _context8.n = 3;
            return sha256("".concat(customerId, ":").concat(customerEmail));
          case 3:
            code = _context8.v;
            _context8.n = 4;
            return fetch("".concat(CABAUSPACE_API_BASE_URL, "/api/recommendation"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                code: code,
                email: customerEmail,
                customer: customerId
              })
            });
          case 4:
            response = _context8.v;
            if (!response.ok) {
              _context8.n = 6;
              break;
            }
            _context8.n = 5;
            return response.json();
          case 5:
            json = _context8.v;
            data = json.data || json;
            if (!(data && data.metabolicSummary)) {
              _context8.n = 6;
              break;
            }
            // Recommendation exists - show quiz summary directly
            console.log('Recommendation gevonden, toon quiz summary');
            if (json.quizResultId) storedQuizResultId = json.quizResultId;
            if (typeformContainer) typeformContainer.style.display = 'none';
            if (loader) loader.style.display = 'none';
            renderQuizResults(data);
            if (resultsContainer) resultsContainer.style.display = 'block';
            return _context8.a(2);
          case 6:
            _context8.n = 8;
            break;
          case 7:
            _context8.p = 7;
            _t5 = _context8.v;
            console.log('No existing recommendation, showing Typeform:', _t5);
          case 8:
            // No recommendation - show Typeform and start polling
            console.log('Geen recommendation, toon Typeform en start polling');
            if (typeformContainer) typeformContainer.style.display = 'block';
            loadTypeformEmbed();
            if (loader) loader.style.display = 'none';
            if (resultsContainer) resultsContainer.style.display = 'none';

            // Start polling with session_id from typeform container
            sessionId = typeformContainer === null || typeformContainer === void 0 || (_typeformContainer$da2 = typeformContainer.dataset) === null || _typeformContainer$da2 === void 0 ? void 0 : _typeformContainer$da2.sessionId;
            if (sessionId) {
              startQuizPolling(sessionId);
            }
          case 9:
            return _context8.a(2);
        }
      }, _callee8, null, [[2, 7]]);
    }));
    return function checkForRecommendationOrShowQuiz() {
      return _ref9.apply(this, arguments);
    };
  }();

  // Wait for recommendation to be completed
  var waitForRecommendation = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(sessionId) {
      var pollUrl, maxAttempts, attemptCount, pollInterval, response, json, status, data;
      return _regenerator().w(function (_context12) {
        while (1) switch (_context12.p = _context12.n) {
          case 0:
            pollUrl = "".concat(CABAUSPACE_API_BASE_URL, "/api/quiz-result/").concat(encodeURIComponent(sessionId));
            maxAttempts = 60; // 60 attempts = 2 minutes max
            attemptCount = 0;
            pollInterval = 2000; // Poll every 2 seconds
            
          case 1:
            if (!(attemptCount < maxAttempts)) {
              _context12.n = 10;
              break;
            }
            
            _context12.n = 2;
            return fetch(pollUrl, {
              method: 'GET',
              headers: {
                'Accept': 'application/json'
              }
            });
          case 2:
            response = _context12.v;
            
            if (!response.ok) {
              _context12.n = 7;
              break;
            }
            
            _context12.n = 3;
            return response.json();
          case 3:
            json = _context12.v;
            status = json.status || json.data && json.data.status;
            data = json.data || json;
            
            if (!(status === 'COMPLETED' && data && data.metabolicSummary)) {
              _context12.n = 5;
              break;
            }
            
            console.log('Recommendation completed:', data);
            return _context12.a(2, data);
            
          case 5:
            console.log('Status:', status, '- waiting...');
            
          case 7:
            // Wait before next attempt
            _context12.n = 8;
            return new Promise(function(resolve) { setTimeout(resolve, pollInterval); });
          case 8:
            attemptCount++;
            _context12.n = 1;
            break;
            
          case 10:
            throw new Error('Timeout waiting for recommendation');
        }
      }, _callee12);
    }));
    return function waitForRecommendation(sessionId) {
      return _ref12.apply(this, arguments);
    };
  }();

  // Legacy polling logic - kept for backward compatibility
  var startQuizPolling = function startQuizPolling(sessionId) {
    var sessionPollUrl = "".concat(CABAUSPACE_API_BASE_URL, "/api/quiz-result/").concat(encodeURIComponent(sessionId));
    var intervalMs = 2000;
    var pollIntervalId = null;
    var loader = document.getElementById('cabauspace-loading-screen');
    var resultsContainer = document.getElementById('quiz-summary-results');
    var typeformContainer = document.getElementById('typeform-container');
    var progressBar = document.getElementById('cabauspace-progress-bar');
    var loadingText = document.querySelector('.cabauspace-loading-text');
    var loadingStages = [{
      percentage: 0,
      text: 'Analyseren van jouw metabole type...'
    }, {
      percentage: 33,
      text: 'Berekenen van eiwitbehoefte...'
    }, {
      percentage: 66,
      text: 'Supplementen matchen aan jouw stressprofiel...'
    }, {
      percentage: 90,
      text: 'Jouw Cabau Lifestyle Plan is klaar!'
    }];
    var progressDuration = 40000;
    var progressInterval = 100;
    var progressElapsed = 0;
    var progressIntervalId = null;
    var hasShownLoader = false;
    var isPollingRecommendation = false;
    var animationStartTime = Date.now();
    var minimumAnimationDuration = 5000; // Minimum 5 seconds animation
    console.log('Quiz polling gestart (session_id):', sessionPollUrl);
    
    // Start progress bar animation immediately
    progressIntervalId = setInterval(function () {
      progressElapsed += progressInterval;
      var pct = Math.min(progressElapsed / progressDuration * 100, 100);
      if (progressBar) {
        progressBar.style.width = pct + '%';
      }
      if (loadingText) {
        for (var i = loadingStages.length - 1; i >= 0; i--) {
          if (pct >= loadingStages[i].percentage) {
            loadingText.textContent = loadingStages[i].text;
            break;
          }
        }
      }
      if (progressElapsed >= progressDuration) clearInterval(progressIntervalId);
    }, progressInterval);
    var pollOnce = /*#__PURE__*/function () {
      var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var _dash$dataset5, _dash$dataset6, response, json, status, data, _dash$dataset3, _dash$dataset4, _customerId, _customerEmail, customerId, customerEmail, code, recResponse, recJson, recData, _t6;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              _context9.p = 0;
              if (isPollingRecommendation) {
                _context9.n = 5;
                break;
              }
              _context9.n = 1;
              return fetch(sessionPollUrl, {
                method: 'GET',
                headers: {
                  'Accept': 'application/json'
                }
              });
            case 1:
              response = _context9.v;
              if (response.ok) {
                _context9.n = 2;
                break;
              }
              console.log('Session nog niet beschikbaar, blijf pollen...');
              // Keep Typeform visible while waiting for session to be created
              return _context9.a(2);
            case 2:
              _context9.n = 3;
              return response.json();
            case 3:
              json = _context9.v;
              status = json.status || json.data && json.data.status;
              data = json.data || json;
              console.log('Session poll status:', status);

              // COMPLETED - render quiz summary directly for guest users
              if (!(status === 'COMPLETED' && data && data.metabolicSummary)) {
                _context9.n = 4;
                break;
              }
              console.log('Guest user - quiz COMPLETED, render summary');
              
              // Calculate remaining animation time
              var elapsedTime = Date.now() - animationStartTime;
              var remainingTime = Math.max(0, minimumAnimationDuration - elapsedTime);
              
              console.log('Elapsed time:', elapsedTime, 'ms, waiting', remainingTime, 'ms before showing results');
              
              // Wait for minimum animation duration before showing results
              setTimeout(function() {
                if (typeformContainer) typeformContainer.style.display = 'none';
                if (loader) loader.style.display = 'none';
                renderQuizResults(data);
                if (resultsContainer) resultsContainer.style.display = 'block';
                
                // Stop polling
                if (pollIntervalId) clearInterval(pollIntervalId);
                if (progressIntervalId) clearInterval(progressIntervalId);
                if (progressBar) progressBar.style.width = '100%';
              }, remainingTime);
              
              return _context9.a(2);
            case 4:
              // PROCESSING - show loader only after hiding Typeform, switch to recommendation polling for logged-in users
              if (status === 'PROCESSING' && !hasShownLoader) {
                console.log('Status PROCESSING - verberg Typeform, toon loader');
                hasShownLoader = true;
                if (typeformContainer) typeformContainer.style.display = 'none';
                if (loader) loader.style.display = 'flex';

                // Progress bar animation already started at the beginning of startQuizPolling
                // No need to start it again here

                // Switch to recommendation polling for logged-in users
                _customerId = dash === null || dash === void 0 || (_dash$dataset3 = dash.dataset) === null || _dash$dataset3 === void 0 ? void 0 : _dash$dataset3.customerId;
                _customerEmail = dash === null || dash === void 0 || (_dash$dataset4 = dash.dataset) === null || _dash$dataset4 === void 0 ? void 0 : _dash$dataset4.customerEmail;
                if (_customerId && _customerEmail) {
                  console.log('Logged-in user - switch naar recommendation polling');
                  isPollingRecommendation = true;
                } else {
                  console.log('Guest user - blijf session endpoint pollen');
                }
              }

              // Keep polling (WAITING or PROCESSING)
              return _context9.a(2);
            case 5:
              // Poll recommendation endpoint until COMPLETED (or continue polling session for guests)
              customerId = dash === null || dash === void 0 || (_dash$dataset5 = dash.dataset) === null || _dash$dataset5 === void 0 ? void 0 : _dash$dataset5.customerId;
              customerEmail = dash === null || dash === void 0 || (_dash$dataset6 = dash.dataset) === null || _dash$dataset6 === void 0 ? void 0 : _dash$dataset6.customerEmail; // For guest users, keep polling session endpoint until data is available
              if (!(!customerId || !customerEmail)) {
                _context9.n = 6;
                break;
              }
              console.log('Guest user - blijf session endpoint pollen...');
              return _context9.a(2);
            case 6:
              _context9.n = 7;
              return sha256("".concat(customerId, ":").concat(customerEmail));
            case 7:
              code = _context9.v;
              _context9.n = 8;
              return fetch("".concat(CABAUSPACE_API_BASE_URL, "/api/recommendation"), {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  code: code,
                  email: customerEmail,
                  customer: customerId
                })
              });
            case 8:
              recResponse = _context9.v;
              if (recResponse.ok) {
                _context9.n = 9;
                break;
              }
              console.log('Recommendation nog niet klaar, blijf pollen...');
              return _context9.a(2);
            case 9:
              _context9.n = 10;
              return recResponse.json();
            case 10:
              recJson = _context9.v;
              recData = recJson.data || recJson;
              if (!(!recData || !recData.metabolicSummary)) {
                _context9.n = 11;
                break;
              }
              console.log('Recommendation data nog niet compleet, blijf pollen...');
              return _context9.a(2);
            case 11:
              console.log('Recommendation COMPLETED, render quiz summary');

              // Calculate remaining animation time
              var recElapsedTime = Date.now() - animationStartTime;
              var recRemainingTime = Math.max(0, minimumAnimationDuration - recElapsedTime);
              
              console.log('Recommendation elapsed time:', recElapsedTime, 'ms, waiting', recRemainingTime, 'ms before showing results');
              
              // Wait for minimum animation duration before showing results
              setTimeout(function() {
                // Render results
                renderQuizResults(recData);

                // Show results, hide loader
                if (loader) loader.style.display = 'none';
                if (resultsContainer) resultsContainer.style.display = 'block';

                // Stop polling
                if (pollIntervalId) clearInterval(pollIntervalId);
                if (progressIntervalId) clearInterval(progressIntervalId);
                if (progressBar) progressBar.style.width = '100%';
              }, recRemainingTime);
              
              _context9.n = 13;
              break;
            case 12:
              _context9.p = 12;
              _t6 = _context9.v;
              console.error('Poll error:', _t6);
            case 13:
              return _context9.a(2);
          }
        }, _callee9, null, [[0, 12]]);
      }));
      return function pollOnce() {
        return _ref0.apply(this, arguments);
      };
    }();
    pollOnce();
    pollIntervalId = setInterval(pollOnce, intervalMs);
  };

  // ===== SCORES =====
  var parseMetabolicSummary = function parseMetabolicSummary(summaryRaw) {
    if (!summaryRaw || typeof summaryRaw !== 'string') return {
      summary: '',
      quote: '',
      areas: [],
      summarypoints: [],
      futurePath: null,
      name: ''
    };
    var cleaned = summaryRaw.trim().replace(/^```json/i, '').replace(/```$/i, '').trim();
    try {
      var parsed = JSON.parse(cleaned);
      var summary = parsed.summary || '';
      var quote = parsed.quote || '';
      var areas = parsed.graphs && Array.isArray(parsed.graphs.areas) ? parsed.graphs.areas : [];
      var summarypoints = Array.isArray(parsed.summarypoints) ? parsed.summarypoints : [];
      var name = parsed.name || '';
      var futurePath = null;
      if (parsed.future_path && Array.isArray(parsed.future_path.steps)) {
        futurePath = {
          steps: parsed.future_path.steps
        };
      }
      return {
        summary: summary,
        quote: quote,
        areas: areas,
        summarypoints: summarypoints,
        futurePath: futurePath,
        name: name
      };
    } catch (e) {
      return {
        summary: summaryRaw,
        quote: '',
        areas: [],
        summarypoints: [],
        futurePath: null,
        name: ''
      };
    }
  };

  // ===== QUIZ RESULTS RENDERING =====
  var storedQuizResultId = null;
  var quizAllProducts = [];
  var quizActiveIndices = [];
  var quizHiddenIndices = [];
  var quizOpenSwapSlot = null;
  var renderSummaryPointsHtml = function renderSummaryPointsHtml(summarypoints) {
    if (!Array.isArray(summarypoints) || summarypoints.length === 0) return '';
    return '<ul>' + summarypoints.map(function (point) {
      return "<li>".concat(escapeHtml(point), "</li>");
    }).join('') + '</ul>';
  };
  var renderQuizResults = function renderQuizResults(result) {
    var container = document.getElementById('quiz-summary-results');
    if (!container || !result) return;
    var meta = parseMetabolicSummary(result.metabolicSummary);
    var products = Array.isArray(result.recommendedProducts) ? result.recommendedProducts : [];
    quizAllProducts = products;
    window.cabauspaceAllProducts = products;

    // Klaviyo Tracking: Cabauspace - Quiz summery (via backend)
    try {
      var quizSummaryContainer = document.getElementById('quiz-summary-results');
      var trackEmail = quizSummaryContainer && quizSummaryContainer.dataset.customerEmail;
      var trackCustomerId = quizSummaryContainer && quizSummaryContainer.dataset.customerId;
      if (!trackEmail && dash) trackEmail = dash.dataset.customerEmail;
      if (!trackCustomerId && dash) trackCustomerId = dash.dataset.customerId;
      if (trackEmail && trackCustomerId) {
        var scores = {};
        if (meta.areas && Array.isArray(meta.areas)) {
          meta.areas.forEach(function (area) { scores[area.name] = area.score; });
        }
        var recommendedProducts = products.map(function (p) { return { product_name: p.title || '', count: 1 }; });
        var weekData = [];
        if (meta.futurePath && Array.isArray(meta.futurePath.steps) && meta.futurePath.steps.length) {
          var _stepsSorted = [].concat(meta.futurePath.steps).sort(function (a, b) { return (a.order || 0) - (b.order || 0); });
          var _weekLabels = ['WEEK 1', 'WEEK 2', 'WEEK 3', 'WEEK 4'];
          _stepsSorted.forEach(function (step, i) {
            weekData.push({ week_label: _weekLabels[i] || 'WEEK ' + (i + 1), week_title: step.focus || '', week_description: step.short_description || '' });
          });
        }
        var finalScores = scores;
        var finalWeekData = weekData;
        var finalRecommendedProducts = recommendedProducts;
        sha256(trackCustomerId + ':' + trackEmail).then(function(trackHash) {
          fetch(CABAUSPACE_API_BASE_URL + '/api/klaviyo/quiz-summary', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              email: trackEmail,
              hash: trackHash,
              scores: finalScores,
              summary: meta.summary || '',
              summary_points: meta.summarypoints || [],
              recommended_products: finalRecommendedProducts,
              week_data: finalWeekData,
              quiz_link: window.location && window.location.href ? window.location.href : ''
            })
          }).catch(function(e) { console.error('Klaviyo tracking failed:', e); });
        });
      }
    } catch (kErr) {
      console.error('Klaviyo Quiz Summary tracking failed:', kErr);
    }

    // Initialize indices
    quizActiveIndices = [];
    quizHiddenIndices = [];
    if (products.length > 0) {
      var maxActive = Math.min(3, products.length);
      for (var i = 0; i < maxActive; i++) quizActiveIndices.push(i);
      for (var _i = maxActive; _i < products.length; _i++) quizHiddenIndices.push(_i);
    }

    // Scores HTML
    var scoresHtml = (meta.areas || []).map(function (area) {
      var score = Number(area.score) || 0;
      var clamped = Math.max(0, Math.min(score, 10));
      var pct = clamped / 10 * 100;
      var isLow = clamped <= 4;
      var statusLabel = isLow ? 'Aandacht nodig' : 'Goed op weg';
      var statusClass = isLow ? 'cs-status-low' : 'cs-status-good';
      var bubbleColor = clamped <= 2 ? '#d64545' : clamped <= 3 ? '#e07a3a' : clamped <= 4 ? '#e8a840' : clamped <= 6 ? '#9ab855' : '#5fa85f';
      return "<li class=\"cs-score-row\">\n        <span class=\"cs-score-label\">".concat(escapeHtml(area.name), "</span>\n        <div class=\"cs-score-bar-wrap\">\n          <div class=\"cs-score-track\">\n            <div class=\"cs-score-white\" style=\"left:").concat(pct, "%\"></div>\n            <div class=\"cs-score-indicator\" style=\"left:").concat(pct, "%\">\n              <span class=\"cs-score-bubble\" style=\"background-color:").concat(bubbleColor, ";color:white\">").concat(clamped, "</span>\n              <span class=\"cs-score-status ").concat(statusClass, "\">").concat(statusLabel, "</span>\n            </div>\n          </div>\n        </div>\n        <span class=\"cs-score-value\">").concat(clamped, "/10</span>\n      </li>");
    }).join('');

    // Roadmap HTML
    var roadmapHtml = '';
    if (meta.futurePath && Array.isArray(meta.futurePath.steps) && meta.futurePath.steps.length) {
      var stepsSorted = _toConsumableArray(meta.futurePath.steps).sort(function (a, b) {
        return (a.order || 0) - (b.order || 0);
      });
      var weekLabels = ['WEEK 1', 'WEEK 2', 'WEEK 3', 'WEEK 4'];
      var heartsHtml = stepsSorted.map(function (step, i) {
        return "\n        <div class=\"cs-timeline-node cs-timeline-node-".concat(i + 1, "\">\n          <div class=\"cs-heart-circle\">\n            <svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n              <path d=\"M12 21C12 21 4 14.5 4 9.5C4 6.46 6.46 4 9.5 4C11.04 4 12.5 4.81 13.28 6.07C14.06 4.81 15.52 4 17.06 4C20.1 4 22.56 6.46 22.56 9.5C22.56 14.5 14.56 21 14.56 21H12Z\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n            </svg>\n          </div>\n        </div>\n      ");
      }).join('');
      var stepsHtml = stepsSorted.map(function (step, i) {
        var focus = step.focus || '';
        var desc = step.short_description || '';
        var weekLabel = weekLabels[i] || 'WEEK ' + (i + 1);
        return "<div class=\"cs-roadmap-card cs-roadmap-card-".concat(i + 1, "\">\n          <div class=\"cs-roadmap-header\">\n            <div class=\"cs-mobile-heart-wrapper\" style=\"display:none;\">\n              <svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                <path d=\"M12 21C12 21 4 14.5 4 9.5C4 6.46 6.46 4 9.5 4C11.04 4 12.5 4.81 13.28 6.07C14.06 4.81 15.52 4 17.06 4C20.1 4 22.56 6.46 22.56 9.5C22.56 14.5 14.56 21 14.56 21H12Z\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n              </svg>\n            </div>\n            <span>").concat(weekLabel, " | ").concat(escapeHtml(focus).toUpperCase(), "</span>\n          </div>\n          <div class=\"cs-roadmap-body\"><p>").concat(escapeHtml(desc), "</p></div>\n        </div>");
      }).join('');
      roadmapHtml = " </div>\n  <section class=\"cs-roadmap-section\">\n    <h2 class=\"cs-roadmap-title\">Waar je naartoe kunt in 4 weken</h2>\n    <p class=\"cs-roadmap-subtitle\">We nemen je mee in een 4-weken challenge, waarbij je elke week een nieuwe uitdaging krijgt om stap voor stap metabolisch gezonder te worden.</p>\n    <div class=\"cs-timeline\">\n      <div class=\"cs-timeline-line\"></div>\n      ".concat(heartsHtml, "\n    </div>\n    <div class=\"cs-roadmap-grid\">").concat(stepsHtml, "</div>\n  </section>\n  <div  class=\"cs-wrapper\">");
    }
    container.innerHTML = "\n<div class=\"cs-wrapper\">\n  <!-- Header sectie -->\n  <header class=\"cs-header\">\n    <h1 class=\"cs-main-title\">Metabolisch resultaat van ".concat(meta.name ? escapeHtml(meta.name) : 'jou', "</h1>\n    ").concat(meta.summary ? "<p class=\"cs-main-subtitle\">".concat(escapeHtml(meta.summary), "</p>") : '', "\n  </header>\n\n  <!-- Twee kolommen sectie -->\n  <section class=\"cs-content-section\">\n    <div class=\"cs-content-left\">\n      <h1 class=\"cs-lorem-title\">In het kort:</h2>\n      ").concat(meta.summarypoints.length ? "<div class=\"cs-bullet-points\">".concat(renderSummaryPointsHtml(meta.summarypoints), "</div>") : '', "\n      <button class=\"cs-btn-outline\" id=\"cabauspace-start-scroll-btn\">START JOUW PLAN</button>\n    </div>\n    <div class=\"cs-content-right\">\n      <h1 class=\"cs-scores-title\">Jouw scores:</h3>\n      <ul class=\"cs-scores-list\">").concat(scoresHtml, "</ul>\n    </div>\n  </section>\n\n  ").concat(roadmapHtml, "\n\n  <section class=\"cabauspace-products-section\">\n    <div class=\"cabauspace-products-header\" style=\"text-align: center; margin-bottom: 2rem;\">\n      <h2 id=\"cabauspace-starter-package\" style=\"margin-bottom: 0.5rem;\">Jouw starterspakket</h2>\n      <p style=\"max-width: 800px; margin: 0 auto; line-height: 1.5; color: #5a3d35;\">Samengesteld op basis van jouw metabolisch profiel, selecteer de producten die je wilt. Je plan is gebaseerd op deze producten.</p>\n    </div>\n    <div class=\"cabauspace-products-grid\" id=\"quiz-products-grid\"></div>\n\n    <!-- Hier komt de horizontale wissel-sectie -->\n    <div id=\"quiz-swap-section-container\"></div>\n\n    <div class=\"cabauspace-plan-buttons\" style=\"display: flex; align-items: stretch; justify-content: center; gap: 1rem; flex-wrap: wrap;\">\n      <div id=\"quiz-pricing-info\" style=\"padding: 0.9rem 1.5rem; min-width: 370px; display: none; order: 2;\">\n        <div class=\"pricing-content\"></div>\n      </div>\n <p class=\"cs-bottom-quote-text\">\n Begin vandaag en werk de komende 4 weken stap voor stap aan jouw doelen.  </p>\n   <button type=\"button\" id=\"quiz-plan-onetime\" class=\"cabauspace-plan-button\" style=\"order: 3;\">\n        Start jouw persoonlijk plan\n      </button>\n    </div>\n     <section class=\"cs-bottom-quote\">\n      <p class=\"cs-bottom-quote-text\">\n              ").concat(meta.quote ? "<blockquote>".concat(escapeHtml(meta.quote), "</blockquote>") : '', "\n      </p>\n    </section>\n    \n    <!-- Reset Quiz Button -->\n    <div style=\"margin-top: 2rem; text-align: center; padding-bottom: 2rem;\">\n      <button\n        id=\"reset-quiz-btn-summary\"\n        class=\"reset-quiz-button\"\n        style=\"background: #5c1026; color: white; padding: 0.875rem 2rem; border: none; font-size: 0.9rem; font-weight: 500; cursor: pointer; text-transform: uppercase; letter-spacing: 0.05em; transition: all 0.3s ease;\">\n        Verwijder het resultaat en vul opnieuw in\n      </button>\n    </div>\n  </section>\n\n</div>\n    ");

    // Hide the quiz questions wrapper when showing results
    var quizWrapper = document.getElementById('custom-quiz-wrapper');
    if (quizWrapper) quizWrapper.style.display = 'none';

    // Render products grid
    updateQuizProductsGrid();

    // Setup buttons
    setupQuizPlanButton();
    setupQuizScrollButton();
    initResetQuizButton();
  };
  var renderQuizProductCard = function renderQuizProductCard(p, slotIndex, isSwapItem) {
    if (!p) return '';
    var images = Array.isArray(p.images) ? p.images : [];
    var variants = Array.isArray(p.variants) ? p.variants : [];
    var firstVariant = variants[0] || null;
    var mainImage = null,
      hoverImage = null;
    var defaultVariantId = firstVariant ? firstVariant.id : null;
    if (defaultVariantId && images.length > 0) {
      var matchedImage = images.find(function (img) {
        return Array.isArray(img.variantIds) && img.variantIds.some(function (id) {
          return String(id) === String(defaultVariantId);
        });
      });
      if (matchedImage) {
        var _images$filter$;
        mainImage = matchedImage.src;
        hoverImage = ((_images$filter$ = images.filter(function (img) {
          return img !== matchedImage;
        })[0]) === null || _images$filter$ === void 0 ? void 0 : _images$filter$.src) || null;
      }
    }
    if (!mainImage && images.length > 0) {
      var _images$;
      mainImage = images[0].src;
      hoverImage = ((_images$ = images[1]) === null || _images$ === void 0 ? void 0 : _images$.src) || null;
    }
    var hasRealChoice = variants.length > 1;
    var variantSelect = hasRealChoice ? "<div class=\"cabauspace-variant-select-wrap\"><select class=\"cabauspace-variant-select\">".concat(variants.map(function (v) {
      return "<option value=\"".concat(v.id, "\">").concat(escapeHtml(v.title), "</option>");
    }).join(''), "</select></div>") : '';
    var price = (firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.price) || null;
    var productUrl = '/products/' + (p.handle || '');
    var recommendedQty = p.quantity && p.quantity > 0 ? p.quantity : 1;
    var checkboxHtml = !isSwapItem ? "<label class=\"cabauspace-checkbox-label\"><input type=\"checkbox\" class=\"cabauspace-checkbox-input cabauspace-toggle-check\" data-slot=\"".concat(slotIndex, "\" checked /><span class=\"cabauspace-checkbox-custom\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"10\" height=\"10\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"white\" stroke-width=\"1\"><path d=\"M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6\"/><path d=\"M3 6h18\"/><path d=\"M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2\"/></svg></span></label>") : '';
    var wisselButtonHtml = !isSwapItem && slotIndex !== -1 ? "<button type=\"button\" class=\"cabauspace-wissel-btn\" data-slot=\"".concat(slotIndex, "\">\u27F3 Wissel</button>") : '';
    var adviceText = "Aan de hand van het aantal porties dat in de ".concat(escapeHtml(p.title), " zit adviseren wij het volgende aantal voor jouw persoonlijke plan.");
    var quantitySelectorHtml = !isSwapItem ? "<div class=\"cabauspace-quantity-controls\">\n        <button type=\"button\" class=\"cabauspace-qty-btn cabauspace-qty-minus\" data-slot=\"".concat(slotIndex, "\">\u2212</button>\n        <input type=\"number\" class=\"cabauspace-qty-input\" value=\"").concat(recommendedQty, "\" min=\"1\" max=\"99\" data-slot=\"").concat(slotIndex, "\" />\n        <button type=\"button\" class=\"cabauspace-qty-btn cabauspace-qty-plus\" data-slot=\"").concat(slotIndex, "\">+</button>\n      </div>\n      <div class=\"cabauspace-info-icon\">\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n          <circle cx=\"12\" cy=\"12\" r=\"10\"></circle>\n          <line x1=\"12\" y1=\"16\" x2=\"12\" y2=\"12\"></line>\n          <line x1=\"12\" y1=\"8\" x2=\"12.01\" y2=\"8\"></line>\n        </svg>\n        <div class=\"cabauspace-tooltip-text\">").concat(adviceText, "</div>\n      </div>") : '';
    return "<article class=\"cabauspace-product-card ".concat(isSwapItem ? 'cabauspace-swap-card' : '', "\" data-default-variant-id=\"").concat((firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.id) || '', "\" data-product-handle=\"").concat(p.handle || '', "\" data-recommended-qty=\"").concat(recommendedQty, "\" ").concat(isSwapItem ? "data-swap-source=\"".concat(slotIndex, "\" data-swap-target-idx=\"").concat(quizAllProducts.indexOf(p), "\"") : "data-slot-index=\"".concat(slotIndex, "\""), ">\n      <div class=\"cabauspace-product-image-wrap\">\n        <a href=\"").concat(productUrl, "\" class=\"cabauspace-product-image-link\" target=\"_blank\" ").concat(isSwapItem ? 'style="pointer-events:none;"' : '', ">\n          ").concat(mainImage ? "<img src=\"".concat(mainImage, "\" alt=\"").concat(escapeHtml(p.title), "\" class=\"cabauspace-product-image cabauspace-img-primary\" />") : '', "\n          ").concat(hoverImage ? "<img src=\"".concat(hoverImage, "\" alt=\"").concat(escapeHtml(p.title), "\" class=\"cabauspace-product-image cabauspace-img-secondary\" />") : '', "\n        </a>\n        ").concat(checkboxHtml, "\n      </div>\n      <div class=\"cabauspace-product-info\">\n        <h3 class=\"cabauspace-product-title\">").concat(escapeHtml(p.title).toUpperCase(), "</h3>\n        ").concat(variantSelect, "\n        ").concat(price ? "<div class=\"cabauspace-product-price\">\u20AC ".concat(price, "</div>") : '', "\n        <p class=\"cabauspace-product-reason\">").concat(escapeHtml(p.reason || ''), "</p>\n        <div class=\"cabauspace-actions-row\">").concat(wisselButtonHtml).concat(quantitySelectorHtml, "</div>\n      </div>\n    </article>");
  };
  var updateQuizProductsGrid = function updateQuizProductsGrid() {
    var html = '';
    var activeCount = quizActiveIndices.length;
    var hiddenCount = quizHiddenIndices.length;
    quizActiveIndices.forEach(function (prodIndex, slotIndex) {
      html += renderQuizProductCard(quizAllProducts[prodIndex], slotIndex, false);
    });

    // Add cards for adding more products
    if (hiddenCount > 0 && activeCount < 5) {
      for (var targetCount = activeCount + 1; targetCount <= 5; targetCount++) {
        var needed = targetCount - activeCount;
        if (hiddenCount < needed) break;
        var discountText = '';
        if (targetCount === 3) discountText = '<b>-15%</b> op jouw starterspakket';else if (targetCount === 4) discountText = '<b>-20%</b> op jouw starterspakket';else if (targetCount >= 5) discountText = '<b>-25%</b> op jouw starterspakket';
        html += "<article class=\"cabauspace-product-card cabauspace-add-card\" data-target-count=\"".concat(targetCount, "\" style=\"cursor: pointer; justify-content: center; align-items: center; text-align: center;\">\n          <div style=\"font-size: 3rem; line-height: 1; color: #a0475a;\">+</div>\n          <h3 class=\"cabauspace-product-title\" style=\"margin-top: 0.5rem; line-height:1.5rem; color: #a0475a;\">").concat(discountText, "</h3>\n        </article>");
      }
    }
    var gridContainer = document.getElementById('quiz-products-grid');
    if (gridContainer) {
      gridContainer.innerHTML = html;
      attachQuizGridEvents();
    }
    setTimeout(function () {
      return updateQuizPricingDisplay();
    }, 0);
  };
  var attachQuizGridEvents = function attachQuizGridEvents() {
    // Wissel buttons
    document.querySelectorAll('#quiz-products-grid .cabauspace-wissel-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        toggleQuizSwapSection(parseInt(btn.dataset.slot, 10));
      });
    });
    // Add cards
    document.querySelectorAll('#quiz-products-grid .cabauspace-add-card').forEach(function (card) {
      card.addEventListener('click', function () {
        var target = parseInt(card.dataset.targetCount, 10);
        if (target) quizAddUpTo(target);
      });
    });
    // Checkboxes
    document.querySelectorAll('#quiz-products-grid .cabauspace-toggle-check').forEach(function (cb) {
      cb.addEventListener('change', function () {
        if (!this.checked) quizRemoveProduct(parseInt(this.dataset.slot, 10));
        updateQuizPricingDisplay();
      });
    });
    // Checkbox labels
    document.querySelectorAll('#quiz-products-grid .cabauspace-checkbox-label').forEach(function (label) {
      label.addEventListener('click', function (e) {
        e.preventDefault();
        var input = label.querySelector('.cabauspace-checkbox-input');
        if (input) {
          input.checked = !input.checked;
          input.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        }
      });
    });
    // Variant selects
    document.querySelectorAll('#quiz-products-grid .cabauspace-variant-select').forEach(function (select) {
      select.addEventListener('change', function () {
        var selectedId = this.value;
        var card = this.closest('.cabauspace-product-card');
        if (card && selectedId) {
          var handle = card.dataset.productHandle;
          if (handle && Array.isArray(quizAllProducts)) {
            var product = quizAllProducts.find(function (p) {
              return p && p.handle === handle;
            });
            if (product && Array.isArray(product.images)) {
              var images = product.images;
              var matchedImage = images.find(function (img) {
                return Array.isArray(img.variantIds) && img.variantIds.some(function (id) {
                  return String(id) === String(selectedId);
                });
              });
              var mainSrc = null;
              var hoverSrc = null;
              if (matchedImage) {
                mainSrc = matchedImage.src;
                var otherImages = images.filter(function (img) {
                  return img !== matchedImage;
                });
                hoverSrc = otherImages.length > 0 ? otherImages[0].src : null;
              } else {
                mainSrc = images[0] ? images[0].src : null;
                hoverSrc = images[1] ? images[1].src : null;
              }
              var primaryImg = card.querySelector('.cabauspace-img-primary');
              var secondaryImg = card.querySelector('.cabauspace-img-secondary');
              if (primaryImg && mainSrc) {
                primaryImg.src = mainSrc;
              }
              if (secondaryImg) {
                if (hoverSrc) {
                  secondaryImg.src = hoverSrc;
                  secondaryImg.style.display = '';
                } else {
                  secondaryImg.style.display = 'none';
                }
              }
            }
          }
        }
        updateQuizPricingDisplay();
      });
    });
    // Quantity buttons
    document.querySelectorAll('#quiz-products-grid .cabauspace-qty-minus').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var input = document.querySelector("#quiz-products-grid .cabauspace-qty-input[data-slot=\"".concat(btn.dataset.slot, "\"]"));
        if (input) {
          var val = parseInt(input.value, 10) || 1;
          if (val > 1) {
            input.value = val - 1;
            updateQuizPricingDisplay();
          }
        }
      });
    });
    document.querySelectorAll('#quiz-products-grid .cabauspace-qty-plus').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var input = document.querySelector("#quiz-products-grid .cabauspace-qty-input[data-slot=\"".concat(btn.dataset.slot, "\"]"));
        if (input) {
          var val = parseInt(input.value, 10) || 1;
          if (val < 99) {
            input.value = val + 1;
            updateQuizPricingDisplay();
          }
        }
      });
    });
  };
  var quizRemoveProduct = function quizRemoveProduct(slotIndex) {
    var prodIdx = quizActiveIndices[slotIndex];
    quizActiveIndices.splice(slotIndex, 1);
    quizHiddenIndices.unshift(prodIdx);
    if (quizOpenSwapSlot === slotIndex) {
      quizOpenSwapSlot = null;
      var container = document.getElementById('quiz-swap-section-container');
      if (container) container.innerHTML = '';
    }
    updateQuizProductsGrid();
  };
  var quizAddUpTo = function quizAddUpTo(targetCount) {
    while (quizActiveIndices.length < targetCount && quizActiveIndices.length < 5 && quizHiddenIndices.length > 0) {
      quizActiveIndices.push(quizHiddenIndices.shift());
    }
    updateQuizProductsGrid();
  };
  var toggleQuizSwapSection = function toggleQuizSwapSection(slotIndex) {
    var container = document.getElementById('quiz-swap-section-container');
    if (!container) return;
    if (quizOpenSwapSlot === slotIndex) {
      container.innerHTML = '';
      quizOpenSwapSlot = null;
      return;
    }
    quizOpenSwapSlot = slotIndex;
    var currentProduct = quizAllProducts[quizActiveIndices[slotIndex]];
    var currentTitle = currentProduct !== null && currentProduct !== void 0 && currentProduct.title ? escapeHtml(currentProduct.title) : '';
    var html = "<div class=\"cabauspace-swap-horizontal-section\"><h2 style=\"text-align:center; margin-bottom: 1rem; color: #5c1026;\">Kies een ander product".concat(currentTitle ? ' voor ' + currentTitle : '', "</h2><div class=\"cabauspace-swap-horizontal-grid\">");
    quizHiddenIndices.slice(0, 5).forEach(function (hiddenIdx) {
      html += renderQuizProductCard(quizAllProducts[hiddenIdx], slotIndex, true);
    });
    html += '</div></div>';
    container.innerHTML = html;
    container.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest'
    });
    container.querySelectorAll('.cabauspace-swap-card').forEach(function (item) {
      item.addEventListener('click', function () {
        var targetIdx = parseInt(item.dataset.swapTargetIdx, 10);
        var hiddenArrIdx = quizHiddenIndices.indexOf(targetIdx);
        if (hiddenArrIdx === -1) return;
        var oldProdIndex = quizActiveIndices[slotIndex];
        quizActiveIndices[slotIndex] = targetIdx;
        quizHiddenIndices[hiddenArrIdx] = oldProdIndex;
        quizOpenSwapSlot = null;
        container.innerHTML = '';
        updateQuizProductsGrid();
      });
    });
  };
  var updateQuizPricingDisplay = function updateQuizPricingDisplay() {
    var items = collectQuizSelectedItems();
    var pricingElement = document.getElementById('quiz-pricing-info');
    if (!pricingElement) return;
    if (items.length === 0) {
      pricingElement.style.display = 'none';
      return;
    }
    var totalPrice = items.reduce(function (sum, item) {
      return sum + parseFloat(item.price || 0) * (item.quantity || 1);
    }, 0);
    var uniqueProductCount = new Set(items.map(function (item) {
      return item.handle;
    }).filter(function (h) {
      return h;
    })).size;
    var discountPercentage = 0;
    if (uniqueProductCount >= 5) discountPercentage = 25;else if (uniqueProductCount >= 4) discountPercentage = 20;else if (uniqueProductCount >= 3) discountPercentage = 15;
    if (discountPercentage > 0) {
      var discountedPrice = totalPrice * (1 - discountPercentage / 100);
      pricingElement.style.display = 'block';
      pricingElement.innerHTML = "<div style=\"color: #a0475a;\"><div style=\"display: flex; align-items: baseline; gap: 0.75rem; margin-bottom: 0.5rem;\"><div><span style=\"text-transform: uppercase;letter-spacing: .08em;font-weight: 400;\">Pakketprijs -".concat(discountPercentage, "%:</span><span style=\"font-weight: 700; margin-left: 0.25rem;\">\u20AC").concat(discountedPrice.toFixed(2), "</span></div><div style=\"text-decoration: line-through; opacity: 0.6; font-size: 0.9rem;\">\u20AC").concat(totalPrice.toFixed(2), "</div></div></div>");
    } else {
      pricingElement.style.display = 'block';
      pricingElement.innerHTML = "<div style=\"color: #5c1026;\"><div><span style=\"text-transform: uppercase;letter-spacing: .08em;font-weight: 400;\">Pakketprijs:</span><span style=\"font-weight: 700; margin-left: 0.25rem;\">\u20AC".concat(totalPrice.toFixed(2), "</span></div></div>");
    }
  };
  var collectQuizSelectedItems = function collectQuizSelectedItems() {
    var cards = document.querySelectorAll('#quiz-products-grid .cabauspace-product-card:not(.cabauspace-add-card)');
    var items = [];
    cards.forEach(function (card) {
      var _card$querySelector;
      var checkbox = card.querySelector('.cabauspace-checkbox-input');
      if (!checkbox || !checkbox.checked) return;
      var variantId = ((_card$querySelector = card.querySelector('.cabauspace-variant-select')) === null || _card$querySelector === void 0 ? void 0 : _card$querySelector.value) || card.dataset.defaultVariantId;
      if (!variantId) return;
      var handle = card.dataset.productHandle || '';
      var qtyInput = card.querySelector('.cabauspace-qty-input');
      var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var fullProduct = (window.cabauspaceAllProducts || []).find(function (p) {
        return p.handle === handle;
      }) || {};
      var price = 0;
      if (fullProduct.variants && Array.isArray(fullProduct.variants)) {
        var selectedVariant = fullProduct.variants.find(function (v) {
          return String(v.id) === String(variantId);
        });
        if (selectedVariant) price = parseFloat(selectedVariant.price) || 0;
      }
      items.push(_objectSpread(_objectSpread({}, fullProduct), {}, {
        variantId: Number(variantId),
        quantity: quantity,
        handle: handle,
        price: price
      }));
    });
    return items;
  };
  var setupQuizPlanButton = function setupQuizPlanButton() {
    var btn = document.getElementById('quiz-plan-onetime');
    if (!btn) return;
    btn.addEventListener('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
      var items;
      return _regenerator().w(function (_context0) {
        while (1) switch (_context0.n) {
          case 0:
            items = collectQuizSelectedItems();
            if (!(items.length === 0)) {
              _context0.n = 1;
              break;
            }
            return _context0.a(2);
          case 1:
            // Klaviyo Tracking: Cabauspace - Start plan btn (via backend)
            try {
              var quizContainer = document.getElementById('quiz-summary-results');
              var trackEmail = quizContainer && quizContainer.dataset.customerEmail;
              var trackCustomerId = quizContainer && quizContainer.dataset.customerId;
              if (!trackEmail && dash) trackEmail = dash.dataset.customerEmail;
              if (!trackCustomerId && dash) trackCustomerId = dash.dataset.customerId;
              if (trackEmail && trackCustomerId) {
                var purchasedProducts = items.map(function (item) {
                  return { product_name: item.title || '', reason: item.reason || '', quantity: item.quantity || 1, price: parseFloat(item.price || 0) };
                });
                var allRecommendedProducts = (window.cabauspaceAllProducts || []).map(function (p) { return { product_name: p.title || '' }; });
                var totalValue = items.reduce(function (sum, i) { return sum + parseFloat(i.price || 0) * (i.quantity || 1); }, 0);
                var totalProducts = items.reduce(function (sum, i) { return sum + (i.quantity || 1); }, 0);
                var uniqueProductHandles = new Set(items.map(function (item) { return item.handle; }).filter(function (h) { return h; }));
                var uniqueProductCount = uniqueProductHandles.size;
                var discountPercentage = 0;
                if (uniqueProductCount >= 5) discountPercentage = 25;
                else if (uniqueProductCount >= 4) discountPercentage = 20;
                else if (uniqueProductCount >= 3) discountPercentage = 15;
                var packagePrice = discountPercentage > 0 ? totalValue * (1 - discountPercentage / 100) : totalValue;
                var finalPurchasedProducts = purchasedProducts;
                var finalAllRecommendedProducts = allRecommendedProducts;
                var finalTotalValue = totalValue;
                var finalPackagePrice = packagePrice;
                var finalDiscountPercentage = discountPercentage;
                var finalTotalProducts = totalProducts;
                sha256(trackCustomerId + ':' + trackEmail).then(function(trackHash) {
                  fetch(CABAUSPACE_API_BASE_URL + '/api/klaviyo/start-plan', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      email: trackEmail,
                      hash: trackHash,
                      purchased_products: finalPurchasedProducts,
                      recommended_products: finalAllRecommendedProducts,
                      total_purchase_amount: finalTotalValue,
                      package_price: finalPackagePrice,
                      discount_percentage: finalDiscountPercentage,
                      number_of_products: finalTotalProducts
                    })
                  }).catch(function(e) { console.error('Klaviyo tracking failed:', e); });
                });
              }
            } catch (kErr) {
              console.error('Klaviyo Start plan btn tracking failed:', kErr);
            }
            showPlanLoadingOverlay();
            _context0.n = 2;
            return Promise.all([sendQuizStartPlanRequest(items), addQuizItemsToCart(items)]);
          case 2:
            return _context0.a(2);
        }
      }, _callee0);
    })));
  };
  var setupQuizScrollButton = function setupQuizScrollButton() {
    var btn = document.getElementById('cabauspace-start-scroll-btn');
    var target = document.getElementById('cabauspace-starter-package');
    if (btn && target) {
      btn.addEventListener('click', function () {
        return target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });
    }
  };
  var sendQuizStartPlanRequest = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(items) {
      var _typeformContainer$da3;
      var typeformContainer, customQuizWrapper, quizResultId, _t7;
      return _regenerator().w(function (_context1) {
        while (1) switch (_context1.p = _context1.n) {
          case 0:
            typeformContainer = document.getElementById('typeform-container');
            customQuizWrapper = document.getElementById('custom-quiz-wrapper');
            quizResultId = storedQuizResultId || (typeformContainer === null || typeformContainer === void 0 || (_typeformContainer$da3 = typeformContainer.dataset) === null || _typeformContainer$da3 === void 0 ? void 0 : _typeformContainer$da3.sessionId) || (customQuizWrapper === null || customQuizWrapper === void 0 ? void 0 : customQuizWrapper.dataset.sessionId);
            console.log('sendQuizStartPlanRequest - storedQuizResultId:', storedQuizResultId, 'quizResultId:', quizResultId);
            if (quizResultId) {
              _context1.n = 1;
              break;
            }
            console.error('sendQuizStartPlanRequest - No quizResultId found, cannot start plan');
            return _context1.a(2);
          case 1:
            _context1.p = 1;
            _context1.n = 2;
            return fetch("".concat(CABAUSPACE_API_BASE_URL, "/api/plan/start"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                quiz_result_id: quizResultId,
                selected_products: items
              })
            });
          case 2:
            _context1.n = 4;
            break;
          case 3:
            _context1.p = 3;
            _t7 = _context1.v;
            console.error('Start plan error:', _t7);
          case 4:
            return _context1.a(2);
        }
      }, _callee1, null, [[1, 3]]);
    }));
    return function sendQuizStartPlanRequest(_x7) {
      return _ref10.apply(this, arguments);
    };
  }();
  var addQuizItemsToCart = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(items) {
      var _window$StikkySDK3;
      var uniqueProductCount, variantIds, totalPrice, bundleProps, bundleAttributes, discountResult, stikkySuccess, stikkyItems, addResult, _t8;
      return _regenerator().w(function (_context10) {
        while (1) switch (_context10.p = _context10.n) {
          case 0:
            uniqueProductCount = new Set(items.map(function (item) {
              return item.handle;
            }).filter(function (h) {
              return h;
            })).size;
            variantIds = items.map(function (item) {
              return item.variantId || item.id;
            });
            totalPrice = items.reduce(function (sum, item) {
              return sum + parseFloat(item.price || 0) * (item.quantity || 1);
            }, 0); // Get bundle properties for discount tracking
            bundleProps = getBundleProperties();
            bundleAttributes = Object.entries(bundleProps).map(function (_ref12) {
              var _ref13 = _slicedToArray(_ref12, 2),
                key = _ref13[0],
                value = _ref13[1];
              return {
                key: key,
                value: value
              };
            }); // STEP 1: Request bundle discount (get code)
            _context10.n = 1;
            return requestBundleDiscount(uniqueProductCount, variantIds, totalPrice);
          case 1:
            discountResult = _context10.v;
            // STEP 2: Try StikkySDK first
            stikkySuccess = false;
            if (!((_window$StikkySDK3 = window.StikkySDK) !== null && _window$StikkySDK3 !== void 0 && (_window$StikkySDK3 = _window$StikkySDK3.actions) !== null && _window$StikkySDK3 !== void 0 && _window$StikkySDK3.addItemsToCart)) {
              _context10.n = 7;
              break;
            }
            _context10.p = 2;
            stikkyItems = items.map(function (item) {
              return {
                variantId: String(item.variantId),
                quantity: item.quantity || 1,
                productId: item.id ? String(item.id) : undefined,
                attributes: bundleAttributes
              };
            });
            _context10.n = 3;
            return window.StikkySDK.actions.addItemsToCart({
              items: stikkyItems
            });
          case 3:
            addResult = _context10.v;
            addResult.fold(function () {
              stikkySuccess = false;
            }, function () {
              stikkySuccess = true;
            });
            if (!stikkySuccess) {
              _context10.n = 5;
              break;
            }
            if (!(discountResult !== null && discountResult !== void 0 && discountResult.discount_code)) {
              _context10.n = 4;
              break;
            }
            _context10.n = 4;
            return applyDiscountToCart(discountResult.discount_code);
          case 4:
            return _context10.a(2);
          case 5:
            _context10.n = 7;
            break;
          case 6:
            _context10.p = 6;
            _t8 = _context10.v;
            console.warn('StikkySDK addItemsToCart failed:', _t8);
            stikkySuccess = false;
          case 7:
            if (!(discountResult !== null && discountResult !== void 0 && discountResult.discount_code)) {
              _context10.n = 8;
              break;
            }
            _context10.n = 8;
            return applyDiscountToCart(discountResult.discount_code);
          case 8:
            if (!(window.Rebuy && window.Rebuy.Cart)) {
              _context10.n = 9;
              break;
            }
            items.forEach(function (item) {
              window.Rebuy.Cart.addItem({
                id: Number(item.variantId),
                quantity: item.quantity || 1,
                properties: Object.assign({}, bundleProps)
              }, {
                open_cart: true
              });
            });
            _context10.n = 10;
            break;
          case 9:
            _context10.n = 10;
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                items: items.map(function (i) {
                  return {
                    id: i.variantId,
                    quantity: i.quantity || 1,
                    properties: Object.assign({}, bundleProps)
                  };
                })
              })
            });
          case 10:
            return _context10.a(2);
        }
      }, _callee10, null, [[2, 6]]);
    }));
    return function addQuizItemsToCart(_x8) {
      return _ref11.apply(this, arguments);
    };
  }();
  var renderScores = function renderScores(areas) {
    var scoresList = document.getElementById('scores-list');
    var scoresSection = document.getElementById('scores-section');
    if (!scoresList || !scoresSection || !areas || !areas.length) return;
    var scoresHtml = areas.map(function (area) {
      var score = Number(area.score) || 0;
      var clamped = Math.max(0, Math.min(score, 10));
      var pct = clamped / 10 * 100;
      var isLow = clamped <= 4;
      var statusLabel = isLow ? 'Aandacht nodig' : 'Goed op weg';
      var statusClass = isLow ? 'cs-status-low' : 'cs-status-good';
      var bubbleColor = clamped <= 2 ? '#d64545' : clamped <= 3 ? '#e07a3a' : clamped <= 4 ? '#e8a840' : clamped <= 6 ? '#9ab855' : '#5fa85f';
      return "<li class=\"cs-score-row\">\n        <span class=\"cs-score-label\">".concat(escapeHtml(area.name), "</span>\n        <div class=\"cs-score-bar-wrap\">\n          <div class=\"cs-score-track\">\n            <div class=\"cs-score-white\" style=\"left:").concat(pct, "%\"></div>\n            <div class=\"cs-score-indicator\" style=\"left:").concat(pct, "%\">\n              <span class=\"cs-score-bubble\" style=\"background-color:").concat(bubbleColor, ";color:white\">").concat(clamped, "</span>\n              <span class=\"cs-score-status ").concat(statusClass, "\">").concat(statusLabel, "</span>\n            </div>\n          </div>\n        </div>\n        <span class=\"cs-score-value\">").concat(clamped, "/10</span>\n      </li>");
    }).join('');
    scoresList.innerHTML = scoresHtml;
    scoresSection.style.display = 'block';
  };

  // ===== PRODUCTS =====
  var dashboardAllProducts = [];
  var dashboardActiveIndices = [];
  var dashboardHiddenIndices = [];
  var renderDashboardProductCard = function renderDashboardProductCard(p, slotIndex, isSwapItem) {
    var recommendedQty = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    if (!p) return '';
    var images = Array.isArray(p.images) ? p.images : [];
    var variants = Array.isArray(p.variants) ? p.variants : [];
    var firstVariant = variants[0] || null;
    var mainImage = null;
    var hoverImage = null;
    var defaultVariantId = firstVariant ? firstVariant.id : null;
    if (defaultVariantId && images.length > 0) {
      var matchedImage = images.find(function (img) {
        return Array.isArray(img.variantIds) && img.variantIds.some(function (id) {
          return String(id) === String(defaultVariantId);
        });
      });
      if (matchedImage) {
        mainImage = matchedImage.src;
        var otherImages = images.filter(function (img) {
          return img !== matchedImage;
        });
        hoverImage = otherImages.length > 0 ? otherImages[0].src : null;
      }
    }
    if (!mainImage && images.length > 0) {
      mainImage = images[0].src;
      hoverImage = images[1] ? images[1].src : null;
    }
    var price = (firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.price) || null;
    var productUrl = '/products/' + (p.handle || '');
    var hasRealChoice = variants.length > 1;
    var variantSelect = hasRealChoice ? "<div class=\"cabauspace-variant-select-wrap\"><select class=\"cabauspace-variant-select\">".concat(variants.map(function (v) {
      return "<option value=\"".concat(v.id, "\">").concat(escapeHtml(v.title), "</option>");
    }).join(''), "</select></div>") : '';
    var checkboxHtml = !isSwapItem ? "<label class=\"cabauspace-checkbox-label\"><input type=\"checkbox\" class=\"cabauspace-checkbox-input cabauspace-toggle-check\" data-slot=\"".concat(slotIndex, "\" checked /><span class=\"cabauspace-checkbox-custom\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"10\" height=\"10\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"white\" stroke-width=\"1\"><path d=\"M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6\"/><path d=\"M3 6h18\"/><path d=\"M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2\"/></svg></span></label>") : '';
    var wisselButtonHtml = !isSwapItem ? "<button type=\"button\" class=\"cabauspace-wissel-btn\" data-slot=\"".concat(slotIndex, "\">\u27F3 Wissel</button>") : '';
    var quantitySelectorHtml = !isSwapItem ? "<div class=\"cabauspace-quantity-controls\"><button type=\"button\" class=\"cabauspace-qty-btn cabauspace-qty-minus\" data-slot=\"".concat(slotIndex, "\">\u2212</button><input type=\"number\" class=\"cabauspace-qty-input\" value=\"").concat(recommendedQty, "\" min=\"1\" max=\"99\" data-slot=\"").concat(slotIndex, "\" /><button type=\"button\" class=\"cabauspace-qty-btn cabauspace-qty-plus\" data-slot=\"").concat(slotIndex, "\">+</button></div>") : '';
    return "<article class=\"cabauspace-product-card ".concat(isSwapItem ? 'cabauspace-swap-card' : '', "\" data-default-variant-id=\"").concat((firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.id) || '', "\" data-product-handle=\"").concat(p.handle || '', "\" data-recommended-qty=\"").concat(recommendedQty, "\" ").concat(isSwapItem ? "data-swap-source=\"".concat(slotIndex, "\" data-swap-target-idx=\"").concat(dashboardAllProducts.indexOf(p), "\"") : "data-slot-index=\"".concat(slotIndex, "\""), ">\n      <div class=\"cabauspace-product-image-wrap\">\n        <a href=\"").concat(productUrl, "\" class=\"cabauspace-product-image-link\" target=\"_blank\" ").concat(isSwapItem ? 'style="pointer-events:none;"' : '', ">\n          ").concat(mainImage ? "<img src=\"".concat(mainImage, "\" alt=\"").concat(escapeHtml(p.title), "\" class=\"cabauspace-product-image cabauspace-img-primary\" />") : '', "\n          ").concat(hoverImage ? "<img src=\"".concat(hoverImage, "\" alt=\"").concat(escapeHtml(p.title), "\" class=\"cabauspace-product-image cabauspace-img-secondary\" />") : '', "\n        </a>\n        ").concat(checkboxHtml, "\n      </div>\n      <div class=\"cabauspace-product-info\">\n        <h3 class=\"cabauspace-product-title\">").concat(escapeHtml(p.title).toUpperCase(), "</h3>\n        ").concat(variantSelect, "\n        ").concat(price ? "<div class=\"cabauspace-product-price\">\u20AC ".concat(price, "</div>") : '', "\n        <p class=\"cabauspace-product-reason\">").concat(escapeHtml(p.reason || ''), "</p>\n        <div class=\"cabauspace-actions-row\">").concat(wisselButtonHtml).concat(quantitySelectorHtml, "</div>\n      </div>\n    </article>");
  };
  var attachDashboardProductEvents = function attachDashboardProductEvents() {
    document.querySelectorAll('#dashboard-products-grid .cabauspace-wissel-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        toggleDashboardSwapSection(parseInt(btn.dataset.slot, 10));
      });
    });
    document.querySelectorAll('#dashboard-products-grid .cabauspace-add-card').forEach(function (card) {
      card.addEventListener('click', function () {
        var target = parseInt(card.dataset.targetCount, 10);
        if (target) {
          dashboardAddUpTo(target);
          updateDashboardPricingDisplay();
        }
      });
    });
    document.querySelectorAll('#dashboard-products-grid .cabauspace-toggle-check').forEach(function (cb) {
      cb.addEventListener('change', function () {
        if (!this.checked) dashboardRemoveProduct(parseInt(this.dataset.slot, 10));
        updateDashboardPricingDisplay();
      });
    });
    document.querySelectorAll('#dashboard-products-grid .cabauspace-checkbox-label').forEach(function (label) {
      label.addEventListener('click', function (e) {
        e.preventDefault();
        var input = label.querySelector('.cabauspace-checkbox-input');
        if (input) {
          input.checked = !input.checked;
          input.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        }
      });
    });
    document.querySelectorAll('#dashboard-products-grid .cabauspace-qty-minus').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var input = document.querySelector("#dashboard-products-grid .cabauspace-qty-input[data-slot=\"".concat(btn.dataset.slot, "\"]"));
        if (input) {
          var val = parseInt(input.value, 10) || 1;
          if (val > 1) {
            input.value = val - 1;
            updateDashboardPricingDisplay();
          }
        }
      });
    });
    document.querySelectorAll('#dashboard-products-grid .cabauspace-qty-plus').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var input = document.querySelector("#dashboard-products-grid .cabauspace-qty-input[data-slot=\"".concat(btn.dataset.slot, "\"]"));
        if (input) {
          var val = parseInt(input.value, 10) || 1;
          if (val < 99) {
            input.value = val + 1;
            updateDashboardPricingDisplay();
          }
        }
      });
    });
    document.querySelectorAll('#dashboard-products-grid .cabauspace-qty-input').forEach(function (input) {
      input.addEventListener('change', function () {
        updateDashboardPricingDisplay();
      });
    });
    document.querySelectorAll('#dashboard-products-grid .cabauspace-variant-select').forEach(function (select) {
      select.addEventListener('change', function () {
        var selectedId = this.value;
        var card = this.closest('.cabauspace-product-card');
        if (!card || !selectedId) return;
        var handle = card.dataset.productHandle;
        if (!handle || !Array.isArray(dashboardAllProducts)) return;
        var product = dashboardAllProducts.find(function (p) {
          return p && p.handle === handle;
        });
        if (!product || !Array.isArray(product.images)) return;
        updateDashboardPricingDisplay();
        var images = product.images;
        var matchedImage = images.find(function (img) {
          return Array.isArray(img.variantIds) && img.variantIds.some(function (id) {
            return String(id) === String(selectedId);
          });
        });
        var mainSrc = null;
        var hoverSrc = null;
        if (matchedImage) {
          mainSrc = matchedImage.src;
          var otherImages = images.filter(function (img) {
            return img !== matchedImage;
          });
          hoverSrc = otherImages.length > 0 ? otherImages[0].src : null;
        } else {
          mainSrc = images[0] ? images[0].src : null;
          hoverSrc = images[1] ? images[1].src : null;
        }
        var primaryImg = card.querySelector('.cabauspace-img-primary');
        var secondaryImg = card.querySelector('.cabauspace-img-secondary');
        if (primaryImg && mainSrc) {
          primaryImg.src = mainSrc;
        }
        if (secondaryImg) {
          if (hoverSrc) {
            secondaryImg.src = hoverSrc;
            secondaryImg.style.display = '';
          } else {
            secondaryImg.style.display = 'none';
          }
        }
      });
    });
  };
  var updateDashboardProductGrid = function updateDashboardProductGrid() {
    var quantityMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var gridContainer = document.getElementById('dashboard-products-grid');
    if (!gridContainer) return;
    var html = '';
    dashboardActiveIndices.forEach(function (prodIndex, slotIndex) {
      var p = dashboardAllProducts[prodIndex];
      var qty = quantityMap[p.handle] || p.quantity || 1;
      html += renderDashboardProductCard(p, slotIndex, false, qty);
    });
    if (dashboardHiddenIndices.length > 0 && dashboardActiveIndices.length < 5) {
      for (var targetCount = dashboardActiveIndices.length + 1; targetCount <= 5; targetCount++) {
        var needed = targetCount - dashboardActiveIndices.length;
        if (dashboardHiddenIndices.length < needed) break;
        var plural = needed === 1 ? 'product' : 'producten';
        var discountText = targetCount === 3 ? ' <b>-15%</b> op jouw starterspakket' : targetCount === 4 ? ' <b>-20%</b> op jouw starterspakket' : targetCount === 5 ? ' <b>-25%</b> op jouw starterspakket' : '';
        html += "<article class=\"cabauspace-product-card cabauspace-add-card\" data-target-count=\"".concat(targetCount, "\" style=\"cursor:pointer;justify-content:center;align-items:center;text-align:center;\"><div style=\"font-size:3rem;line-height:1;color:#a0475a;\">+</div><h3 class=\"cabauspace-product-title\" style=\"margin-top:0.5rem;line-height:1.5rem;color:#a0475a;\">").concat(discountText, "</h3></article>");
      }
    }
    gridContainer.innerHTML = html;
    attachDashboardProductEvents();
    setTimeout(function () {
      return updateDashboardPricingDisplay();
    }, 0);
  };
  var dashboardRemoveProduct = function dashboardRemoveProduct(slot) {
    if (slot < 0 || slot >= dashboardActiveIndices.length) return;
    var removedIdx = dashboardActiveIndices.splice(slot, 1)[0];
    dashboardHiddenIndices.push(removedIdx);
    updateDashboardProductGrid();
  };
  var dashboardAddUpTo = function dashboardAddUpTo(targetCount) {
    while (dashboardActiveIndices.length < targetCount && dashboardHiddenIndices.length > 0) {
      dashboardActiveIndices.push(dashboardHiddenIndices.shift());
    }
    updateDashboardProductGrid();
  };
  var toggleDashboardSwapSection = function toggleDashboardSwapSection(slot) {
    var container = document.getElementById('dashboard-swap-section-container');
    if (!container) return;
    if (container.dataset.activeSlot === String(slot)) {
      container.innerHTML = '';
      container.dataset.activeSlot = '';
      return;
    }
    container.dataset.activeSlot = String(slot);
    var currentProduct = dashboardAllProducts[dashboardActiveIndices[slot]];
    var swapIndices = dashboardHiddenIndices.slice(0, 5);
    var swapHtml = "<div class=\"cabauspace-swap-section\"><h4>Kies een ander product voor: ".concat(escapeHtml((currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.title) || ''), "</h4><div class=\"cabauspace-swap-grid\">");
    swapIndices.forEach(function (hiddenIdx) {
      swapHtml += renderDashboardProductCard(dashboardAllProducts[hiddenIdx], slot, true, 1);
    });
    swapHtml += '</div></div>';
    container.innerHTML = swapHtml;
    document.querySelectorAll('#dashboard-swap-section-container .cabauspace-swap-card').forEach(function (card) {
      card.addEventListener('click', function () {
        dashboardSwapProduct(parseInt(card.dataset.swapSource, 10), parseInt(card.dataset.swapTargetIdx, 10));
      });
    });
  };
  var dashboardSwapProduct = function dashboardSwapProduct(sourceSlot, targetIdx) {
    var oldIdx = dashboardActiveIndices[sourceSlot];
    dashboardActiveIndices[sourceSlot] = targetIdx;
    var hiddenPos = dashboardHiddenIndices.indexOf(targetIdx);
    if (hiddenPos !== -1) dashboardHiddenIndices.splice(hiddenPos, 1);
    dashboardHiddenIndices.push(oldIdx);
    var container = document.getElementById('dashboard-swap-section-container');
    if (container) {
      container.innerHTML = '';
      container.dataset.activeSlot = '';
    }
    updateDashboardProductGrid();
  };
  var renderDashboardProducts = function renderDashboardProducts(products, allRecommended) {
    dashboardAllProducts = allRecommended;
    dashboardActiveIndices = [];
    dashboardHiddenIndices = [];
    var boughtHandles = products.map(function (p) {
      return p.handle;
    });
    allRecommended.forEach(function (p, i) {
      boughtHandles.includes(p.handle) ? dashboardActiveIndices.push(i) : dashboardHiddenIndices.push(i);
    });
    if (dashboardActiveIndices.length === 0) {
      var maxActive = Math.min(3, allRecommended.length);
      for (var i = 0; i < maxActive; i++) dashboardActiveIndices.push(i);
      for (var _i2 = maxActive; _i2 < allRecommended.length; _i2++) dashboardHiddenIndices.push(_i2);
    }
    var quantityMap = {};
    products.forEach(function (p) {
      quantityMap[p.handle] = p.quantity || 1;
    });
    updateDashboardProductGrid(quantityMap);
    setupDashboardPlanButtons();
  };

  // ===== BUNDLE DISCOUNT - Token Management =====
  var BUNDLE_TOKEN_KEY = 'cabau_bundle_token';
  var BUNDLE_SOURCE = 'custom_bundle_page';
  var generateUUID = function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      var v = c === 'x' ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
  };
  var getBundleToken = function getBundleToken() {
    var token = localStorage.getItem(BUNDLE_TOKEN_KEY);
    if (!token) {
      token = generateUUID();
      localStorage.setItem(BUNDLE_TOKEN_KEY, token);
    }
    return token;
  };
  var getBundleProperties = function getBundleProperties() {
    return {
      '_bundle_source': BUNDLE_SOURCE
    };
  };

  // Request bundle discount code from backend (returns discount info, does NOT auto-apply)
  var requestBundleDiscount = /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(uniqueProductCount, variantIds, totalPrice) {
      var bundleToken, response, result, _t9;
      return _regenerator().w(function (_context11) {
        while (1) switch (_context11.p = _context11.n) {
          case 0:
            bundleToken = getBundleToken();
            if (!(uniqueProductCount < 3)) {
              _context11.n = 1;
              break;
            }
            return _context11.a(2, null);
          case 1:
            _context11.p = 1;
            _context11.n = 2;
            return fetch(CABAUSPACE_API_BASE_URL + '/api/bundle-discount', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                bundle_token: bundleToken,
                unique_product_count: uniqueProductCount,
                variant_ids: variantIds || [],
                total_price: totalPrice || 0
              })
            });
          case 2:
            response = _context11.v;
            if (response.ok) {
              _context11.n = 3;
              break;
            }
            return _context11.a(2, null);
          case 3:
            _context11.n = 4;
            return response.json();
          case 4:
            result = _context11.v;
            if (!(result.eligible && result.discount_code)) {
              _context11.n = 5;
              break;
            }
            return _context11.a(2, result);
          case 5:
            return _context11.a(2, null);
          case 6:
            _context11.p = 6;
            _t9 = _context11.v;
            return _context11.a(2, null);
        }
      }, _callee11, null, [[1, 6]]);
    }));
    return function requestBundleDiscount(_x9, _x0, _x1) {
      return _ref14.apply(this, arguments);
    };
  }();

  // Apply discount code to cart - uses promise for proper sequencing
  var applyDiscountToCart = /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(discountCode) {
      return _regenerator().w(function (_context13) {
        while (1) switch (_context13.n) {
          case 0:
            return _context13.a(2, new Promise(/*#__PURE__*/function () {
              var _ref16 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(resolve) {
                var _window$StikkySDK4, stikkyResult, iframe, _t0, _t1;
                return _regenerator().w(function (_context12) {
                  while (1) switch (_context12.p = _context12.n) {
                    case 0:
                      _context12.p = 0;
                      console.log('Applying discount code to cart:', discountCode);

                      // Apply via StikkySDK if available
                      if (!((_window$StikkySDK4 = window.StikkySDK) !== null && _window$StikkySDK4 !== void 0 && (_window$StikkySDK4 = _window$StikkySDK4.actions) !== null && _window$StikkySDK4 !== void 0 && _window$StikkySDK4.applyDiscount)) {
                        _context12.n = 4;
                        break;
                      }
                      _context12.p = 1;
                      _context12.n = 2;
                      // Try with both possible parameter names for Stikky SDK compatibility
                      return window.StikkySDK.actions.applyDiscount({ code: discountCode, discountCode: discountCode });
                    case 2:
                      stikkyResult = _context12.v;
                      console.log('Discount code applied via StikkySDK:', discountCode, 'result:', stikkyResult);
                      _context12.n = 4;
                      break;
                    case 3:
                      _context12.p = 3;
                      _t0 = _context12.v;
                      console.warn('StikkySDK discount apply failed:', _t0, 'code:', discountCode);
                    case 4:
                      // Always apply via iframe for Rebuy/Shopify cart (ensures both Stikky AND Rebuy have the discount)
                      iframe = document.createElement('iframe');
                      iframe.style.display = 'none';
                      iframe.onload = function () {
                        console.log('Discount code applied via iframe (Rebuy/Shopify):', discountCode);
                        iframe.remove();
                        if (window.Rebuy && window.Rebuy.Cart && window.Rebuy.Cart.fetchCart) {
                          window.Rebuy.Cart.fetchCart();
                        }
                        resolve(true);
                      };
                      iframe.onerror = function () {
                        console.error('Failed to apply discount via iframe');
                        iframe.remove();
                        resolve(false);
                      };
                      iframe.src = '/discount/' + discountCode + '?redirect=/';
                      document.body.appendChild(iframe);
                      setTimeout(function () {
                        if (iframe.parentNode) {
                          iframe.remove();
                          resolve(true);
                        }
                      }, 3000);
                      _context12.n = 6;
                      break;
                    case 5:
                      _context12.p = 5;
                      _t1 = _context12.v;
                      console.error('Error applying discount to cart:', _t1);
                      resolve(false);
                    case 6:
                      return _context12.a(2);
                  }
                }, _callee12, null, [[1, 3], [0, 5]]);
              }));
              return function (_x11) {
                return _ref16.apply(this, arguments);
              };
            }()));
        }
      }, _callee13);
    }));
    return function applyDiscountToCart(_x10) {
      return _ref15.apply(this, arguments);
    };
  }();

  // ===== CART FUNCTIONS =====
  var updateDashboardPricingDisplay = function updateDashboardPricingDisplay() {
    var items = collectDashboardSelectedItems();
    var pricingElement = document.getElementById('dashboard-pricing-info');
    if (!pricingElement) return;
    if (items.length === 0) {
      pricingElement.style.display = 'none';
      pricingElement.innerHTML = '';
      return;
    }

    // Calculate total price
    var totalPrice = items.reduce(function (sum, item) {
      return sum + parseFloat(item.price || 0) * (item.quantity || 1);
    }, 0);

    // Count unique products
    var uniqueProductHandles = new Set(items.map(function (item) {
      return item.handle;
    }).filter(function (h) {
      return h;
    }));
    var uniqueProductCount = uniqueProductHandles.size;

    // Determine discount percentage
    var discountPercentage = 0;
    if (uniqueProductCount >= 5) discountPercentage = 25;else if (uniqueProductCount >= 4) discountPercentage = 20;else if (uniqueProductCount >= 3) discountPercentage = 15;
    if (discountPercentage > 0) {
      var discountedPrice = totalPrice * (1 - discountPercentage / 100);
      pricingElement.style.display = 'block';
      pricingElement.innerHTML = "\n        <div style=\"color: #a0475a;\">\n          <div style=\"display: flex; align-items: baseline; gap: 0.75rem; margin-bottom: 0.5rem;\">\n            <div>\n              <span style=\"text-transform: uppercase;letter-spacing: .08em;font-weight: 400;\">Pakketprijs -".concat(discountPercentage, "%:</span>\n              <span style=\"font-weight: 700; margin-left: 0.25rem;\">\u20AC").concat(discountedPrice.toFixed(2), "</span>\n            </div>\n            <div style=\"text-decoration: line-through; opacity: 0.6; font-size: 0.9rem;\">\u20AC").concat(totalPrice.toFixed(2), "</div>\n          </div>\n        </div>\n      ");
    } else {
      pricingElement.style.display = 'block';
      pricingElement.innerHTML = "\n        <div style=\"color: #5c1026;\">\n          <div>\n            <span style=\"text-transform: uppercase;letter-spacing: .08em;font-weight: 400;\">Pakketprijs:</span>\n            <span style=\"font-weight: 700; margin-left: 0.25rem;\">\u20AC".concat(totalPrice.toFixed(2), "</span>\n          </div>\n        </div>\n      ");
    }
  };
  var collectDashboardSelectedItems = function collectDashboardSelectedItems() {
    var cards = document.querySelectorAll('#dashboard-products-grid .cabauspace-product-card:not(.cabauspace-add-card)');
    var items = [];
    cards.forEach(function (card) {
      var _card$querySelector2;
      var checkbox = card.querySelector('.cabauspace-checkbox-input');
      if (!checkbox || !checkbox.checked) return;
      var variantId = ((_card$querySelector2 = card.querySelector('.cabauspace-variant-select')) === null || _card$querySelector2 === void 0 ? void 0 : _card$querySelector2.value) || card.dataset.defaultVariantId;
      if (!variantId) return;
      var handle = card.dataset.productHandle || '';
      var qtyInput = card.querySelector('.cabauspace-qty-input');
      var quantity = parseInt(qtyInput === null || qtyInput === void 0 ? void 0 : qtyInput.value, 10) || 1;
      var fullProduct = dashboardAllProducts.find(function (p) {
        return p.handle === handle;
      }) || {};
      var price = 0;
      if (fullProduct.variants) {
        var v = fullProduct.variants.find(function (v) {
          return String(v.id) === String(variantId);
        });
        if (v) price = parseFloat(v.price) || 0;
      }
      items.push(_objectSpread(_objectSpread({}, fullProduct), {}, {
        variantId: Number(variantId),
        quantity: quantity,
        handle: handle,
        price: price
      }));
    });
    return items;
  };
  var dashboardAddItemsOneTime = /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
      var _window$StikkySDK5;
      var items, bundleProps, bundleAttributes, uniqueProductHandles, uniqueProductCount, variantIds, totalPrice, discountResult, stikkySuccess, stikkyItems, addResult, _window$Rebuy, _t10, _t11;
      return _regenerator().w(function (_context14) {
        while (1) switch (_context14.p = _context14.n) {
          case 0:
            items = collectDashboardSelectedItems();
            if (!(items.length === 0)) {
              _context14.n = 1;
              break;
            }
            alert('Selecteer minimaal één product');
            return _context14.a(2);
          case 1:
            showCartOverlay();

            // Get bundle properties for discount tracking
            bundleProps = getBundleProperties();
            bundleAttributes = Object.entries(bundleProps).map(function (_ref18) {
              var _ref19 = _slicedToArray(_ref18, 2),
                key = _ref19[0],
                value = _ref19[1];
              return {
                key: key,
                value: value
              };
            }); // Count unique products for bundle discount (use handle to identify unique products)
            uniqueProductHandles = new Set(items.map(function (item) {
              return item.handle;
            }).filter(function (h) {
              return h;
            }));
            uniqueProductCount = uniqueProductHandles.size; // Calculate total price
            variantIds = items.map(function (item) {
              return item.variantId;
            });
            totalPrice = items.reduce(function (sum, item) {
              return sum + (parseFloat(item.price) || 0) * (item.quantity || 1);
            }, 0); // STEP 1: Request bundle discount (get code, don't apply yet)
            _context14.n = 2;
            return requestBundleDiscount(uniqueProductCount, variantIds, totalPrice);
          case 2:
            discountResult = _context14.v;
            // STEP 2: Try StikkySDK first, fallback to Rebuy/Shopify if it fails
            stikkySuccess = false;
            if (!((_window$StikkySDK5 = window.StikkySDK) !== null && _window$StikkySDK5 !== void 0 && (_window$StikkySDK5 = _window$StikkySDK5.actions) !== null && _window$StikkySDK5 !== void 0 && _window$StikkySDK5.addItemsToCart)) {
              _context14.n = 8;
              break;
            }
            _context14.p = 3;
            stikkyItems = items.map(function (item) {
              return {
                variantId: String(item.variantId),
                quantity: item.quantity || 1,
                productId: item.id ? String(item.id) : undefined,
                attributes: bundleAttributes
              };
            });
            _context14.n = 4;
            return window.StikkySDK.actions.addItemsToCart({
              items: stikkyItems
            });
          case 4:
            addResult = _context14.v;
            // Check if StikkySDK actually succeeded
            addResult.fold(function () {
              stikkySuccess = false;
            }, function () {
              stikkySuccess = true;
            });
            if (!stikkySuccess) {
              _context14.n = 6;
              break;
            }
            if (!(discountResult !== null && discountResult !== void 0 && discountResult.discount_code)) {
              _context14.n = 5;
              break;
            }
            _context14.n = 5;
            return applyDiscountToCart(discountResult.discount_code);
          case 5:
            hideCartOverlay();
            return _context14.a(2);
          case 6:
            _context14.n = 8;
            break;
          case 7:
            _context14.p = 7;
            _t10 = _context14.v;
            stikkySuccess = false;
          case 8:
            _context14.p = 8;
            if (!(discountResult !== null && discountResult !== void 0 && discountResult.discount_code)) {
              _context14.n = 9;
              break;
            }
            _context14.n = 9;
            return applyDiscountToCart(discountResult.discount_code);
          case 9:
            if (!(window.Rebuy && window.Rebuy.Cart)) {
              _context14.n = 10;
              break;
            }
            items.forEach(function (item) {
              window.Rebuy.Cart.addItem({
                id: Number(item.variantId),
                quantity: item.quantity || 1,
                properties: Object.assign({}, bundleProps)
              }, {
                open_cart: true
              });
            });
            setTimeout(hideCartOverlay, 2000);
            _context14.n = 12;
            break;
          case 10:
            _context14.n = 11;
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                items: items.map(function (i) {
                  return {
                    id: i.variantId,
                    quantity: i.quantity || 1,
                    properties: Object.assign({}, bundleProps)
                  };
                })
              })
            });
          case 11:
            if ((_window$Rebuy = window.Rebuy) !== null && _window$Rebuy !== void 0 && (_window$Rebuy = _window$Rebuy.Cart) !== null && _window$Rebuy !== void 0 && _window$Rebuy.fetchCart) window.Rebuy.Cart.fetchCart();
            hideCartOverlay();
          case 12:
            _context14.n = 14;
            break;
          case 13:
            _context14.p = 13;
            _t11 = _context14.v;
            hideCartOverlay();
          case 14:
            return _context14.a(2);
        }
      }, _callee14, null, [[8, 13], [3, 7]]);
    }));
    return function dashboardAddItemsOneTime() {
      return _ref17.apply(this, arguments);
    };
  }();
  var setupDashboardPlanButtons = function setupDashboardPlanButtons() {
    var _document$getElementB2;
    (_document$getElementB2 = document.getElementById('dashboard-plan-onetime')) === null || _document$getElementB2 === void 0 || _document$getElementB2.addEventListener('click', dashboardAddItemsOneTime);
  };

  // ===== FETCH RECOMMENDATION (scores + products) =====
  var productsPollTimeoutId = null;
  var showProductsLoadingState = function showProductsLoadingState() {
    var gridContainer = document.getElementById('dashboard-products-grid');
    if (gridContainer && !gridContainer.dataset.pendingState) {
      gridContainer.innerHTML = '<div class="products-loading"><div class="mc-spinner"></div><p>Jouw persoonlijke producten worden nog samengesteld...</p></div>';
      gridContainer.dataset.pendingState = 'true';
    }
  };
  var fetchRecommendationData = function fetchRecommendationData() {
    var customerId = dash.dataset.customerId;
    var customerEmail = dash.dataset.customerEmail;
    if (!customerId || !customerEmail) return;
    clearTimeout(productsPollTimeoutId);
    sha256("".concat(customerId, ":").concat(customerEmail)).then(function (code) {
      return fetch("".concat(CABAUSPACE_API_BASE_URL, "/api/recommendation"), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          code: code,
          email: customerEmail,
          customer: customerId
        })
      });
    }).then(function (response) {
      if (!response.ok) {
        // Nog geen recommendation - toon laadstatus in de tab en probeer het zo weer
        showProductsLoadingState();
        clearTimeout(productsPollTimeoutId);
        productsPollTimeoutId = setTimeout(fetchRecommendationData, 2000);
        return null;
      }
      return response.json();
    }).then(function (result) {
      if (!result) return;
      var gridContainer = document.getElementById('dashboard-products-grid');
      if (gridContainer) gridContainer.dataset.pendingState = '';
      if (result.status === 'COMPLETED' && result.data) {
        var meta = parseMetabolicSummary(result.data.metabolicSummary);
        if (meta.areas && meta.areas.length) renderScores(meta.areas);
        var recommendedProducts = result.data.recommendedProducts || [];
        var boughtProducts = result.boughtProducts || [];
        if (boughtProducts.length > 0) renderDashboardProducts(boughtProducts, recommendedProducts);else if (recommendedProducts.length > 0) renderDashboardProducts(recommendedProducts, recommendedProducts);
      }
    }).catch(function () {
      showProductsLoadingState();
      clearTimeout(productsPollTimeoutId);
      productsPollTimeoutId = setTimeout(fetchRecommendationData, 2000);
    });
  };

  // ===== MEAL PLAN =====
  var renderMealSteps = function renderMealSteps(steps) {
    if (!Array.isArray(steps) || !steps.length) return '';
    return steps.map(function (step, idx) {
      var options = Array.isArray(step.options) ? step.options : [];
      var stepNum = step.step_number || idx + 1;
      return "<div class=\"shuffle-step\"><div class=\"shuffle-step-header\"><span class=\"shuffle-step-icon\"><svg width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\"><circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M12 6v6l4 2\"/></svg></span><span class=\"shuffle-step-label\">Stap ".concat(escapeHtml(String(stepNum)), "</span></div><h4 class=\"shuffle-step-title\">").concat(escapeHtml(step.title || ''), "</h4><ul class=\"shuffle-step-options\">").concat(options.map(function (opt) {
        return "<li>".concat(escapeHtml(opt), "</li>");
      }).join(''), "</ul></div>");
    }).join('');
  };
  var renderMealSection = function renderMealSection(mealType, meal, mealLabel) {
    if (!meal) return '';
    var steps = Array.isArray(meal.steps) ? meal.steps : [];
    var whyText = meal.why_good_for_metabolic_health || '';
    return "<div class=\"shuffle-meal-section\"><h3 class=\"shuffle-meal-title\">".concat(escapeHtml(mealLabel), "</h3>").concat(whyText ? "<div class=\"shuffle-meal-why\">".concat(escapeHtml(whyText), "</div>") : '', "<div class=\"shuffle-steps-row\">").concat(renderMealSteps(steps), "</div></div>");
  };
  var renderSnacksSection = function renderSnacksSection(snacks) {
    if (!Array.isArray(snacks) || !snacks.length) return '';
    return "<div class=\"shuffle-meal-section\"><h3 class=\"shuffle-meal-title\">Snacks</h3><div class=\"shuffle-snacks-grid\">".concat(snacks.map(function (s) {
      return "<div class=\"shuffle-snack-item\">".concat(escapeHtml(s), "</div>");
    }).join(''), "</div></div>");
  };
  var initShuffleWeekNav = function initShuffleWeekNav() {
    var navBtns = document.querySelectorAll('.shuffle-week-nav-btn');
    var weeks = document.querySelectorAll('.shuffle-week');
    navBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var targetWeek = btn.dataset.targetWeek;
        navBtns.forEach(function (b) {
          return b.classList.remove('active');
        });
        btn.classList.add('active');
        weeks.forEach(function (w) {
          w.classList.remove('active');
          if (w.dataset.week === targetWeek) w.classList.add('active');
        });
      });
    });
  };
  var mealPlanPollTimeoutId = null;
  var MEAL_PLAN_POLL_INTERVAL = 2000;
  var _fetchCabauspaceResults = function fetchCabauspaceResults(isPoll) {
    var container = document.getElementById('cabauspace-results');
    if (!container) return;
    var customerId = dash.dataset.customerId;
    var customerEmail = dash.dataset.customerEmail;
    if (!customerId || !customerEmail) return;
    if (!isPoll) {
      clearTimeout(mealPlanPollTimeoutId);
      container.innerHTML = "<div class=\"shuffle-loading\" style=\"text-align:center;padding:3rem 1rem;\"><div class=\"mc-spinner\" style=\"margin:0 auto 1.5rem;\"></div><p style=\"color:#a0475a;font-weight:500;\">Jouw persoonlijke meal plan wordt aangemaakt...</p></div>";
    }
    sha256("".concat(customerId, ":").concat(customerEmail)).then(function (code) {
      return fetch("".concat(CABAUSPACE_API_BASE_URL, "/api/plan"), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          code: code,
          email: customerEmail,
          customer: customerId
        })
      });
    }).then(function (response) {
      if (!response.ok) {
        if (response.status === 404) {
          container.innerHTML = '<p class="shuffle-error">Geen maaltijdplan gevonden. Heb je de quiz al gedaan?</p>';
          return null;
        }
        throw new Error('Backend error');
      }
      return response.json();
    }).then(function (json) {
      if (!json) return;
      if (json.status === 'PROCESSING' || json.status === 'FAILED') {
        // Nog niet klaar - toon laadstatus in de tab zelf en blijf pollen
        container.innerHTML = "<div class=\"shuffle-loading\" style=\"text-align:center;padding:3rem 1rem;\"><div class=\"mc-spinner\" style=\"margin:0 auto 1.5rem;\"></div><p style=\"color:#a0475a;font-weight:500;\">Jouw persoonlijke meal plan wordt nog samengesteld, dit duurt ongeveer 3 minuten...</p></div>";
        clearTimeout(mealPlanPollTimeoutId);
        mealPlanPollTimeoutId = setTimeout(function () {
          fetchCabauspaceResults(true);
        }, MEAL_PLAN_POLL_INTERVAL);
        return;
      }
      var plan = json.data || json || {};
      var weeks = Array.isArray(plan.weeks) ? plan.weeks : [];
      if (!weeks.length) {
        container.innerHTML = '<p class="shuffle-error">Geen maaltijdplan gevonden.</p>';
        return;
      }
      // Use current challenge week to determine which week should be active
      var activeWeekIndex = Math.max(0, Math.min(currentChallengeWeek - 1, weeks.length - 1));
      var weekNavHtml = weeks.map(function (w, i) {
        return "<button class=\"shuffle-week-nav-btn ".concat(i === activeWeekIndex ? 'active' : '', "\" data-target-week=\"").concat(w.week_number, "\"><span class=\"shuffle-week-nav-number\">Week ").concat(w.week_number, "</span></button>");
      }).join('');
      var weeksHtml = weeks.map(function (week, weekIndex) {
        var meals = week.meals || {};
        var grocery = week.grocery_list || {};
        var snacksHtml = renderSnacksSection(meals.snacks);
        var breakfastHtml = renderMealSection('breakfast', meals.breakfast, 'Ontbijt');
        var lunchHtml = renderMealSection('lunch', meals.lunch, 'Lunch');
        var dinnerHtml = renderMealSection('dinner', meals.dinner, 'Diner');
        var groceryHtml = Object.keys(grocery).map(function (cat) {
          var items = Array.isArray(grocery[cat]) ? grocery[cat] : [];
          if (!items.length) return '';
          var niceCat = cat.replace(/_/g, ' ').replace(/\b\w/g, function (c) {
            return c.toUpperCase();
          });
          return "<div class=\"shuffle-grocery-category\"><h4 class=\"shuffle-grocery-title\">".concat(escapeHtml(niceCat), "</h4><ul class=\"shuffle-grocery-list\">").concat(items.map(function (i) {
            return "<li>".concat(escapeHtml(i), "</li>");
          }).join(''), "</ul></div>");
        }).join('');
        return "<div class=\"shuffle-week ".concat(weekIndex === activeWeekIndex ? 'active' : '', "\" data-week=\"").concat(week.week_number, "\"><div class=\"shuffle-week-content\">").concat(breakfastHtml).concat(lunchHtml).concat(dinnerHtml).concat(snacksHtml, "</div><div class=\"shuffle-grocery-section\"><h3 class=\"shuffle-grocery-header\">Boodschappenlijst Week ").concat(escapeHtml(String(week.week_number)), "</h3><div class=\"shuffle-grocery-grid\">").concat(groceryHtml, "</div></div></div>");
      }).join('');
      container.innerHTML = "<div class=\"shuffle-wrapper\"><div class=\"shuffle-header\"><h1>Jouw Shuffle Meal Plan</h1><p class=\"shuffle-intro\">Kies bij elke stap \xE9\xE9n optie. Mix en match voor eindeloze variatie!</p><div class=\"shuffle-week-nav\">".concat(weekNavHtml, "</div></div><div class=\"shuffle-weeks-container\">").concat(weeksHtml, "</div></div>");
      initShuffleWeekNav();
    }).catch(function () {
      container.innerHTML = '<p class="shuffle-error">Er ging iets mis bij het ophalen van je plan.</p>';
    });
  };

  // ===== WORKOUT PLAN =====
  var workoutPlanData = null;
  var workoutLocation = 'home'; // 'home' or 'gym'
  var workoutHashCode = null; // Store hash for swap API calls

  var renderWorkoutExerciseCard = function renderWorkoutExerciseCard(exercise, dayIndex, exerciseIndex) {
    var imageUrl = exercise.image ? "https://be-cabauspace.fly.dev/".concat(exercise.image) : '';
    var description = exercise.description || '';
    return "<article class=\"workout-exercise-card\" data-day=\"".concat(dayIndex, "\" data-exercise=\"").concat(exerciseIndex, "\">\n      <div class=\"workout-exercise-image-wrap\">\n        ").concat(imageUrl ? "<img src=\"".concat(imageUrl, "\" alt=\"").concat(escapeHtml(exercise.name || ''), "\" class=\"workout-exercise-image\" loading=\"lazy\" />") : '', "\n      </div>\n      <div class=\"workout-exercise-info\">\n        <h3 class=\"workout-exercise-name\">").concat(escapeHtml(exercise.name || ''), "</h3>\n        <p class=\"workout-exercise-meta\">").concat(escapeHtml(String(exercise.sets || 3)), " sets \xD7 ").concat(escapeHtml(String(exercise.reps || '')), "</p>\n        ").concat(description ? "<p class=\"workout-exercise-desc\">".concat(escapeHtml(description), "</p>") : '', "\n      </div>\n      <button type=\"button\" class=\"workout-wissel-btn\" data-day=\"").concat(dayIndex, "\" data-exercise=\"").concat(exerciseIndex, "\">\u27F3 Wissel</button>\n    </article>");
  };
  var renderWorkoutDay = function renderWorkoutDay(workout, dayIndex) {
    if (!workout) return '';
    var exercises = workout[workoutLocation] || [];
    var exercisesHtml = exercises.map(function (ex, exIdx) {
      return renderWorkoutExerciseCard(ex, dayIndex, exIdx);
    }).join('');
    var warmUp = workout.warm_up || '';
    return "<div class=\"workout-day-section\" data-day=\"".concat(dayIndex, "\">\n      <div class=\"workout-day-header\">\n        <h3 class=\"workout-day-title\">").concat(escapeHtml(workout.day_label || "Dag ".concat(workout.day)), ": ").concat(escapeHtml(workout.focus || ''), "</h3>\n      </div>\n      ").concat(warmUp ? "<p class=\"workout-warmup\"><strong>Warming-up:</strong> ".concat(escapeHtml(warmUp), "</p>") : '', "\n      <div class=\"workout-exercises-grid\">").concat(exercisesHtml, "</div>\n    </div>");
  };
  var renderWorkoutPlan = function renderWorkoutPlan() {
    var container = document.getElementById('cabauspace-workouts');
    if (!container || !workoutPlanData) return;
    var workouts = Array.isArray(workoutPlanData.workouts) ? workoutPlanData.workouts : [];
    if (!workouts.length) {
      container.innerHTML = '<p class="workout-error">Geen workout plan gevonden.</p>';
      return;
    }
    var introText = workoutPlanData.intro || 'Herhaal dit schema 4 weken voor het beste resultaat.';
    var workoutsHtml = workouts.map(function (w, idx) {
      return renderWorkoutDay(w, idx);
    }).join('');
    container.innerHTML = "<div class=\"workout-wrapper\">\n      <div class=\"workout-header\">\n        <h2 class=\"workout-title\">Jouw Workout Plan</h2>\n        <p class=\"workout-intro\">".concat(escapeHtml(introText), "</p>\n        <div class=\"workout-location-toggle\">\n          <button type=\"button\" class=\"workout-loc-btn ").concat(workoutLocation === 'home' ? 'active' : '', "\" data-loc=\"home\">Thuis</button>\n          <button type=\"button\" class=\"workout-loc-btn ").concat(workoutLocation === 'gym' ? 'active' : '', "\" data-loc=\"gym\">Sportschool</button>\n        </div>\n      </div>\n      <div class=\"workout-days-container\">").concat(workoutsHtml, "</div>\n    </div>");
    initWorkoutEvents();
  };
  var initWorkoutEvents = function initWorkoutEvents() {
    // Location toggle
    document.querySelectorAll('.workout-loc-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        workoutLocation = btn.dataset.loc;
        renderWorkoutPlan();
      });
    });

    // Wissel buttons
    document.querySelectorAll('.workout-wissel-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dayIdx = parseInt(btn.dataset.day, 10);
        var exIdx = parseInt(btn.dataset.exercise, 10);
        showWorkoutSwapModal(dayIdx, exIdx);
      });
    });
  };
  var showWorkoutSwapModal = function showWorkoutSwapModal(dayIndex, exerciseIndex) {
    var workout = workoutPlanData.workouts[dayIndex];
    if (!workout) return;
    var currentExercises = workout[workoutLocation] || [];
    var currentEx = currentExercises[exerciseIndex];
    if (!currentEx) return;

    // Get swap options for this day based on location
    var swapOptionsKey = workoutLocation === 'home' ? 'swap_options_home' : 'swap_options_gym';
    var swapOptions = workout[swapOptionsKey] || [];

    // Render swap section below the day section
    var daySectionEl = document.querySelector(".workout-day-section[data-day=\"".concat(dayIndex, "\"]"));
    if (!daySectionEl) return;

    // Remove any existing swap section
    var existingSwap = document.getElementById('workout-swap-section-container');
    if (existingSwap) existingSwap.remove();
    var swapContainer = document.createElement('div');
    swapContainer.id = 'workout-swap-section-container';
    swapContainer.innerHTML = "<div class=\"workout-swap-section\">\n      <h4>Wissel oefening</h4>\n      <p class=\"workout-swap-current\">Huidig: <strong>".concat(escapeHtml(currentEx.name), "</strong></p>\n      <div class=\"workout-swap-grid\">\n        ").concat(swapOptions.map(function (ex, idx) {
      return "<article class=\"workout-exercise-card workout-swap-card\" data-swap-index=\"".concat(idx, "\">\n          <div class=\"workout-exercise-image-wrap\">\n            <img src=\"https://be-cabauspace.fly.dev/").concat(ex.image, "\" alt=\"").concat(escapeHtml(ex.name), "\" class=\"workout-exercise-image\" loading=\"lazy\" />\n          </div>\n          <div class=\"workout-exercise-info\">\n            <h3 class=\"workout-exercise-name\">").concat(escapeHtml(ex.name), "</h3>\n            <p class=\"workout-exercise-meta\">").concat(escapeHtml(String(ex.sets || 3)), " sets \xD7 ").concat(escapeHtml(String(ex.reps || '')), "</p>\n          </div>\n        </article>");
    }).join(''), "\n      </div>\n    </div>");
    daySectionEl.parentNode.insertBefore(swapContainer, daySectionEl.nextSibling);

    // Scroll to swap section
    swapContainer.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest'
    });

    // Add click handlers to swap cards
    swapContainer.querySelectorAll('.workout-swap-card').forEach(function (card) {
      card.addEventListener('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17() {
        var swapIdx, swapEx, targetExercises, oldExercise, _t14;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.p = _context17.n) {
            case 0:
              swapIdx = parseInt(card.dataset.swapIndex, 10);
              swapEx = swapOptions[swapIdx];
              if (swapEx) {
                _context17.n = 1;
                break;
              }
              return _context17.a(2);
            case 1:
              // Replace current exercise with swap option (locally first for instant feedback)
              targetExercises = workout[workoutLocation];
              oldExercise = targetExercises[exerciseIndex];
              targetExercises[exerciseIndex] = swapEx;

              // Move old exercise to swap options
              swapOptions[swapIdx] = oldExercise;
              swapContainer.remove();
              renderWorkoutPlan();

              // Save swap to database
              if (!workoutHashCode) {
                _context17.n = 5;
                break;
              }
              _context17.p = 2;
              _context17.n = 3;
              return fetch("".concat(CABAUSPACE_API_BASE_URL, "/api/workout/swap"), {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  hash: workoutHashCode,
                  day_index: dayIndex,
                  location: workoutLocation,
                  exercise_index: exerciseIndex,
                  swap_index: swapIdx
                })
              });
            case 3:
              _context17.n = 5;
              break;
            case 4:
              _context17.p = 4;
              _t14 = _context17.v;
              console.error('Failed to save workout swap:', _t14);
            case 5:
              return _context17.a(2);
          }
        }, _callee17, null, [[2, 4]]);
      })));
    });
  };
  var workoutPollTimeoutId = null;
  var WORKOUT_POLL_INTERVAL = 2000;
  var _fetchWorkoutResults = function fetchWorkoutResults(isPoll) {
    var container = document.getElementById('cabauspace-workouts');
    if (!container) return;
    var customerId = dash.dataset.customerId;
    var customerEmail = dash.dataset.customerEmail;
    if (!customerId || !customerEmail) return;
    if (!isPoll) {
      clearTimeout(workoutPollTimeoutId);
      container.innerHTML = "<div class=\"workout-loading\"><div class=\"mc-spinner\"></div><p>Jouw workout plan wordt geladen...</p></div>";
    }
    sha256("".concat(customerId, ":").concat(customerEmail)).then(function (code) {
      workoutHashCode = code; // Store for swap API calls
      return fetch("".concat(CABAUSPACE_API_BASE_URL, "/api/workout"), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          code: code,
          email: customerEmail,
          customer: customerId
        })
      });
    }).then(function (response) {
      if (!response.ok) {
        if (response.status === 404) {
          container.innerHTML = '<p class="workout-error">Geen workout plan gevonden. Heb je de quiz al gedaan?</p>';
          return null;
        }
        throw new Error('Backend error');
      }
      return response.json();
    }).then(function (json) {
      if (!json) return;
      if (json.status === 'PROCESSING' || json.status === 'FAILED') {
        // Nog niet klaar - toon laadstatus in de tab zelf en blijf pollen
        container.innerHTML = "<div class=\"workout-loading\"><div class=\"mc-spinner\"></div><p>Jouw workout plan wordt nog samengesteld, dit duurt ongeveer 3 minuten...</p></div>";
        clearTimeout(workoutPollTimeoutId);
        workoutPollTimeoutId = setTimeout(function () {
          fetchWorkoutResults(true);
        }, WORKOUT_POLL_INTERVAL);
        return;
      }
      workoutPlanData = json.data || json || {};
      renderWorkoutPlan();
    }).catch(function () {
      container.innerHTML = '<p class="workout-error">Er ging iets mis bij het ophalen van je workout plan.</p>';
    });
  };

  // ===== INITIALIZE DASHBOARD =====
  var initializeDashboard = function initializeDashboard() {
    // Don't hide quiz yet - wait until we confirm user has dashboard data
    // Quiz visibility will be controlled by fetchDashboardData result
    var dashboard = document.getElementById('cabau-dashboard');
    if (dashboard) dashboard.style.display = 'block';
    var loginPrompt = document.getElementById('mc-login-prompt');
    var loadingState = document.getElementById('dashboard-loading');
    var userName = document.getElementById('user-name');
    if (userName && dash.dataset.customerName) {
      userName.textContent = dash.dataset.customerName.toUpperCase();
    }
    if (loginPrompt) loginPrompt.style.display = 'none';
    if (loadingState) loadingState.style.display = 'block';
    initDashboardTabs();
    initMoodButtons();
    initChallengeButtons();
    initResetQuizButton();
    fetchDashboardData();
    fetchRecommendationData();
    _fetchCabauspaceResults();
    _fetchWorkoutResults();
  };

  // Custom quiz submission handler
  window.submitCustomQuiz = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(formData) {
      var customQuizWrapper, sessionId, quizContainer, loader, progressBar, loadingText, loadingStages, progressDuration, progressInterval, progressElapsed, progressIntervalId, submitUrl, response, result, resultsContainer;
      return _regenerator().w(function (_context11) {
        while (1) switch (_context11.p = _context11.n) {
          case 0:
            _context11.p = 0;
            console.log('Custom quiz submitted:', formData);
            if (window._dbg) window._dbg('Custom quiz submitted: ' + JSON.stringify(formData));

            // Get session ID from wrapper
            customQuizWrapper = document.getElementById('custom-quiz-wrapper');
            sessionId = customQuizWrapper ? customQuizWrapper.dataset.sessionId : null;

            if (sessionId) {
              _context11.n = 4;
              break;
            }
            console.error('No session ID found');
            return _context11.a(2, new Error('No session ID'));
          case 4:
            console.log('Submitting quiz to API with session_id:', sessionId);
            
            // Store sessionId as quizResultId for later use (e.g., start plan)
            storedQuizResultId = sessionId;

            // Hide quiz form, show loading screen
            quizContainer = document.getElementById('custom-quiz-container');
            loader = document.getElementById('cabauspace-loading-screen');
            if (quizContainer) quizContainer.style.display = 'none';
            if (loader) loader.style.display = 'flex';

            // Start 30 second progress bar animation immediately
            progressBar = document.getElementById('cabauspace-progress-bar');
            loadingText = document.querySelector('.cabauspace-loading-text');
            loadingStages = [{
              percentage: 0,
              text: 'Analyseren van jouw metabole type...'
            }, {
              percentage: 33,
              text: 'Berekenen van eiwitbehoefte...'
            }, {
              percentage: 66,
              text: 'Supplementen matchen aan jouw stressprofiel...'
            }, {
              percentage: 90,
              text: 'Jouw Cabau Lifestyle Plan is klaar!'
            }];
            progressDuration = 40000; // 30 seconds
            progressInterval = 100;
            progressElapsed = 0;
            
            progressIntervalId = setInterval(function () {
              progressElapsed += progressInterval;
              var pct = Math.min(progressElapsed / progressDuration * 100, 100);
              if (progressBar) {
                progressBar.style.width = pct + '%';
              }
              if (loadingText) {
                for (var i = loadingStages.length - 1; i >= 0; i--) {
                  if (pct >= loadingStages[i].percentage) {
                    loadingText.textContent = loadingStages[i].text;
                    break;
                  }
                }
              }
              if (progressElapsed >= progressDuration) {
                clearInterval(progressIntervalId);
              }
            }, progressInterval);

            // Submit to API - formData is already the complete webhook payload
            submitUrl = "".concat(CABAUSPACE_API_BASE_URL, "/api/quiz-result");

            _context11.n = 5;
            return fetch(submitUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify(formData)
            });
          case 5:
            response = _context11.v;
            if (response.ok) {
              _context11.n = 7;
              break;
            }
            throw new Error("API returned status ".concat(response.status));
          case 7:
            _context11.n = 6;
            return response.json();
          case 6:
            result = _context11.v;
            console.log('Quiz submitted successfully:', result);
            if (window._dbg) window._dbg('Quiz API response: ' + JSON.stringify(result));

            // Wait for API to return recommendation data
            _context11.n = 8;
            return waitForRecommendation(sessionId);
          case 8:
            result = _context11.v;
            
            // Stop progress bar animation
            clearInterval(progressIntervalId);
            if (progressBar) progressBar.style.width = '100%';
            
            // Show results
            if (result && result.metabolicSummary) {
              renderQuizResults(result);
              resultsContainer = document.getElementById('quiz-summary-results');
              if (loader) loader.style.display = 'none';
              if (resultsContainer) resultsContainer.style.display = 'block';
            }

            _context11.n = 12;
            break;
          case 10:
            _context11.p = 10;
            _context11.d = _context11.f(10);
            console.error('Error submitting quiz:', _context11.d);
            if (window._dbg) window._dbg('Quiz submit error: ' + _context11.d.message);
            alert('Er ging iets mis bij het verzenden van de quiz. Probeer het opnieuw.');
            // Show quiz form again
            if (quizContainer) quizContainer.style.display = 'flex';
            if (loader) loader.style.display = 'none';
          case 12:
            return _context11.a(2);
          case 14:
          case 2:
            return _context11.f();
        }
      }, _callee11, null, [[0, 10]]);
    }));
    return function (_x3) {
      return _ref11.apply(this, arguments);
    };
  }();
})();
